{
  "DASHBOARD_ACTIONS": {
    "EMPTY": "No actions to complete at the moment.",
    "TITLE": "Your actions to complete",
    "DAY_WITH_COUNT": "For {count} day",
    "DAYS_WITH_COUNT": "For {count} days"
  },
  "repairFileWorkflow": {
    "declaration": {
      "option": "Declared decision (optional)",
      "recipient": "Declared sending recipient",
      "optionalDecision": "Without a decision, the stage is recorded without transmission evidence. The selected date is the declared date."
    },
    "title": "Your next actions",
    "nextAction": "YOUR NEXT ACTION: {action}",
    "pastAction": "ACTION AT THIS STEP: {action}",
    "noValue": "Not provided",
    "remindersActive": "Automatic reminders enabled.",
    "options": {
      "OPTION_1": "Repair package",
      "OPTION_2": "Diagnosis and estimate",
      "OPTION_3": "Recycling",
      "CREDIT_OR_REFUND": "Credit / refund",
      "PRODUCT_REPLACEMENT": "Replacement with a new product",
      "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Product return requested for diagnosis",
      "PRODUCT_REPAIR_WITH_GUARANTEE": "Repair under warranty",
      "TECHNICIAN_ON_SITE_INTERVENTION": "On-site technician intervention",
      "REJECT_PROSPECT": "Support request rejected",
      "OTHER": "Other",
      "DIAGNOSIS": "Diagnosis and estimate",
      "ON_SITE": "On-site technician intervention"
    },
    "events": {
      "PRELIMINARY_INFORMATION_RECEIVED": "ADDITIONAL INFORMATION ABOUT THE REPAIRER RESPONSE. Request number: {request_number}. Comment: {comment}",
      "FILE_CLOSED_DECLARED": "12. FILE MANUALLY CLOSED by {actor} on {date}.",
      "CUSTOMER_AVAILABILITY_DECLARED": "11a. CUSTOMER NOTIFICATION DECLARED by {actor}. Awaiting collection.",
      "CUSTOMER_DECISION_FORWARDED_TO_STORE": "7. DECISION FORWARDED BY SYSTEM TO STORE at {recipient}: {option}. Sending to the repairer still needs to be declared.",
      "BREAKDOWN_REPORTED": "Reported the following issue: {description}.",
      "FILE_CREATION_STARTED": "1. FILE CREATION IN PROGRESS.",
      "PACKAGE_PROPOSAL_SENT": "PACKAGE PROPOSAL SENT TO CUSTOMER. Awaiting customer response since {date}.",
      "PACKAGE_DECISION_RECEIVED": "CUSTOMER DECISION (via email): {option}.",
      "PRELIMINARY_REQUEST_SENT": "Preliminary request sent to {recipient} with the following comments, awaiting their response: {description}.",
      "PRELIMINARY_RESPONSE_RECEIVED": "REPAIRER DECISION (via email): {option}. Preliminary request: manufacturer response. Request number: {request_number}.",
      "PRELIMINARY_RESPONSE_DECLARED": "REPAIRER DECISION (declared by user): {option}. Preliminary request: manufacturer response. Request number: {request_number}.",
      "TRANSPORT_LABELS_REQUESTED": "Your transport request was sent to {recipient} on {date}. You should receive shipping labels shortly.",
      "OUTBOUND_TRANSPORT_STARTED": "2. OUTBOUND TRANSPORT INITIATED since {date}.",
      "REPAIRER_RECEIPT_RECORDED": "3. RECEIVED BY REPAIRER since {date}.",
      "REPAIRER_ESTIMATE_REPORTED_SENT": "4. REPAIRER ESTIMATE SENT to {recipient} since {date}.",
      "REPAIRER_ESTIMATE_INTEGRATED": "5. MANUFACTURER ESTIMATE ADDED TO FILE.",
      "CUSTOMER_ESTIMATE_SENT": "6. ESTIMATE SENT TO CUSTOMER. Awaiting their decision.",
      "CUSTOMER_ESTIMATE_SEND_DECLARED": "6. ESTIMATE SENDING DECLARED OUTSIDE PLATFORM. Awaiting customer decision.",
      "CUSTOMER_DECISION_SENT_TO_REPAIRER": "7. CUSTOMER DECISION SENT TO REPAIRER BY THE SYSTEM: {option}. Processing since {date}.",
      "CUSTOMER_DECISION_SEND_DECLARED": "7. DECISION SENDING TO REPAIRER DECLARED BY STORE: {option}. No customer email approval recorded. Processing since {date}.",
      "CUSTOMER_DECISION_TRANSMISSION_UNVERIFIED": "7. DECISION TRANSMISSION DECLARED. Stage selected without system sending.",
      "REPAIR_STARTED": "8. REPAIR IN PROGRESS since {date}.",
      "REPAIR_PARTS_ORDERED": "8. REPAIR IN PROGRESS — PARTS ORDERED since {date}.",
      "REPAIRER_RETURN_STARTED": "9. SHIPPED BY REPAIRER. Return transport initiated since {date}.",
      "NO_RETURN_TREATMENT_FINALIZED": "9. TREATMENT FINALIZED BY REPAIRER: {option}.",
      "DEPOT_RECEIPT_RECORDED": "10. RECEIVED AT STORE.",
      "CUSTOMER_AVAILABILITY_NOTIFIED": "11a. CUSTOMER INFORMED. Awaiting collection.",
      "CUSTOMER_RETURN_DISPATCHED": "11b. RETURN TRANSPORT TO CUSTOMER INITIATED.",
      "FILE_CLOSED_WITH_RETURN": "12. CUSTOMER HANDOVER DECLARED — FILE CLOSED: {option}.",
      "FILE_CLOSED_WITHOUT_RETURN": "12. FILE CLOSED: {option}. Without return.",
      "BILLING_STAGE_ENTERED": "13. BILLING.",
      "FILE_FINISHED": "14. FILE FINISHED.",
      "PACKAGE_PROPOSAL_QUEUED": "Package proposal prepared. Customer email pending.",
      "PRELIMINARY_REQUEST_QUEUED": "Preliminary request prepared. Repairer email pending.",
      "CUSTOMER_ESTIMATE_QUEUED": "Estimate prepared. Customer email pending.",
      "CUSTOMER_DECISION_QUEUED": "Decision recorded: {option}. Platform transmission pending.",
      "CUSTOMER_RETURN_DELIVERED": "The carrier reports customer delivery on {date}. Closure remains manual.",
      "CUSTOMER_RECEIPT_SMS_SENT": "Product receipt confirmation SMS sent to {phone} on {date}.",
      "CUSTOMER_RECEIPT_CONFIRMED": "The customer confirms product receipt on {date}. Attached photo: Returned product customer photo. Customer comment: {comment}",
      "FILE_ABANDONED": "File abandoned by customer.",
      "FILE_DELETED": "File deleted."
    },
    "actions": {
      "COMPLETE_REPAIR_FILE": "Complete the required information before sending.",
      "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "Click “New action” and continue the process to finalize transport.",
      "CONTACT_SUPPORT_IF_LABELS_MISSING": "If no response within 24 hours, contact BOOMERANG via chat (green bubble), using “I haven’t received my label”.",
      "INTEGRATE_AND_SEND_CUSTOMER_ESTIMATE": "Click “New action” to add the estimate and send it to the customer.",
      "ENTER_ERP_BILLING": "Enter billing in the ERP.",
      "DESCRIBE_CUSTOMER_DECISION": "Record the decision in the comments to enable follow-up.",
      "PROVIDE_DELIVERY_NOTE_AND_WARRANTY": "Have the delivery note signed and provide the warranty extension to the customer."
    }
  },
  "CLIENT_RETURN_TRANSPORT": {
    "TITLE": "Prepare the customer return",
    "SUBTITLE": "Check the recipient’s details, choose transport and prepare the return documents.",
    "STEP_1": "1. Address information",
    "STEP_2": "2. Transport selection",
    "STEP_3": "Shipment",
    "STEP_4": "Final customer-return steps",
    "BOOMERANG": "Send with a BOOMERANG carrier",
    "OWN_MEANS": "Send by your own means",
    "BACK": "Back to repair file",
    "DEPARTURE": "Departure — store",
    "RECIPIENT": "Recipient — customer",
    "CARRIER": "Carrier",
    "SERVICE": "Shipping service",
    "SPECIFIC_INSTRUCTIONS": "Arrange transport with the BOOMERANG team, then enter the carrier and customer-return tracking number here.",
    "DOCUMENTS": "Customer return documents",
    "STEP_11A": "Customer informed — available in store",
    "STEP_11B": "Return transport to the customer",
    "CLIENT_RETURN_ADDRESS": "RETURN - CUSTOMER ADDRESS",
    "LABEL": "Return shipping label (PDF)",
    "UPLOAD_LABEL": "Save return shipping label"
  },
  "ATTACHMENT_UPLOAD": {
    "FROM_COMPUTER": "From computer",
    "VIA_MOBILE": "Via mobile",
    "COMPUTER": "From your computer",
    "MOBILE": "From your phone or tablet",
    "PHOTO_TITLE": "Add photos",
    "DOCUMENT_TITLE": "Add documents",
    "ANY_FORMAT": "All document formats",
    "IMAGES": "JPG, PNG",
    "REMOVE_BEFORE_UPLOAD": "A proof is already saved. Remove it before uploading a replacement.",
    "SESSION_INVALID": "This QR code has expired or is no longer available. Generate a new code to continue.",
    "PARTIAL": "Some files were saved. The unsuccessful files remain selected for retry.",
    "REFRESH_FAILED": "The upload was saved, but the updated list could not be loaded. Refresh the list before adding more files.",
    "LOAD_FAILED": "The current attachments could not be loaded. Retry before uploading.",
    "CAPACITY_REACHED": "The maximum number of saved files has been reached. Remove a file before uploading another.",
    "CAPACITY_EXCEEDED": "The selection exceeds the number of files still allowed.",
    "CAPACITY": "{count} of {max} documents saved · {remaining} available",
    "FILE_TOO_LARGE": "A selected file exceeds the allowed size.",
    "NAME_TOO_LONG": "The filename must contain no more than {max} characters."
  },
  "PUBLIC_DECISION": {
    "UPDATED_SELECTION": "The proposal has changed. Review the updated information before confirming again.",
    "TITLE": "Confirm your choice",
    "SUBTITLE": "Review the proposal below before confirming your decision.",
    "REFERENCE": "File {reference}",
    "TOTAL_COST": "Total cost",
    "CONFIRM": "Confirm this choice",
    "BRAND_LOGO": "Network or store logo",
    "RECORDED_TITLE": "Your choice has been saved",
    "COMPLETED_TITLE": "Information saved",
    "COMPLETED_MESSAGE": "Your information has been saved and its delivery has been queued. You can close this page.",
    "FOLLOWUP_UNAVAILABLE": "Your decision remains saved. Access to the follow-up form has expired or been revoked. Contact the store if you need to add information.",
    "OPTIONAL_ATTACHMENT": "Attachment (optional)",
    "PACKAGE_OPTIONS": {
      "OPTION_1": "Accept the repair package",
      "OPTION_2": "Request a diagnosis and a repairer estimate",
      "OPTION_3": "Do not repair the product"
    },
    "PURCHASE": {
      "TITLE": "Purchase order",
      "OFFER": "You can send a purchase order or reference to the store.",
      "ADD": "Add purchase order",
      "HINT": "The number, reference and document are optional. You can finish without adding information.",
      "ORDER_NUMBER": "Order number (optional)",
      "CALLBACK_REF": "Reference to quote (optional)",
      "COMPLETE_WITHOUT_DETAILS": "Finish without details"
    },
    "MANUFACTURER": {
      "TITLE": "Support information",
      "HINT": "Add the support number and, if needed, return instructions and a document.",
      "SUPPORT_NUMBER": "Support number",
      "RETURN_ADDRESS": "Return address or instructions (optional)",
      "RECIPIENTS": "Recipients",
      "STORE_RECIPIENT": "The store is always informed. Select any additional recipients.",
      "SEND_TO": "Inform {email}",
      "OTHER_RECIPIENTS": "Other recipients (optional)",
      "EMAIL_PLACEHOLDER": "address1{'@'}example.com; address2{'@'}example.com"
    }
  },
  "PUBLIC_UPLOAD": {
    "CAPACITY_EXCEEDED": "The selection exceeds the number of photos still allowed.",
    "PHOTOS": {
      "TITLE": "Add product photos",
      "SUBTITLE": "Add one or more product photos from your mobile device.",
      "DROPZONE": "Drop the photos",
      "FORMATS": "JPG, JPEG, PNG",
      "REMOVE": "Remove photo",
      "SUBMIT": "Send photos",
      "CAPACITY": "{count} / {max} photos saved · {remaining} slot(s) available",
      "PARTIAL": "Some photos have been saved. Retry the remaining photos or return to your computer to confirm those already sent.",
      "FAILED_FILES": "Photos not sent: {names}",
      "FULL": "The maximum number of photos has been reached. Return to your computer to check the file.",
      "SUCCESS_TITLE": "Photos sent",
      "SUCCESS_MESSAGE": "Your photos are saved. Return to your computer to confirm the upload. Generate a new QR code to send more photos."
    },
    "PROOF": {
      "TITLE": "Upload the proof",
      "SUBTITLE": "Upload the proof from your mobile device."
    },
    "ATTACHMENT": {
      "TITLE": "Add an attachment",
      "SUBTITLE": "Upload the document from your mobile device.",
      "NAME": "File name"
    },
    "DOCUMENT": {
      "DROPZONE": "Drop the document",
      "FORMATS": "PDF, JPG, PNG",
      "REMOVE": "Remove document",
      "HINT": "After uploading, return to your computer to confirm.",
      "SUBMIT": "Send document",
      "SUCCESS_TITLE": "Document sent",
      "SUCCESS_MESSAGE": "You can return to your computer and confirm the upload."
    },
    "TAKE_PHOTO": "Take a photo",
    "MAX_SIZE": "Maximum size {size} {unit}",
    "TOO_LARGE": "This file exceeds the maximum allowed size.",
    "REPLACE_PHOTO": "Replace photo",
    "BYTE": "B",
    "KILOBYTE": "KB",
    "MEGABYTE": "MB"
  },
  "STEP_PROSPECT": {
    "TITLE": "File information",
    "SUB_STEP_INFORMATION_CLIENT": {
      "TITLE": "Company contact information for this repair"
    },
    "SUB_STEP_PROSPECT_REQUEST": {
      "TITLE": "Preliminary support request",
      "REFERENCE_IMAGE_ALT": "Reference pictures for the preliminary request",
      "RIGHT_PART": {
        "ADD_PICTURE": {
          "TITLE": "Add the requested pictures to complete the file",
          "SUBTITLE": "Choose an upload method below",
          "INPUT_LABEL_BY_PC": "From your computer",
          "INPUT_LABEL_BY_QR_CODE": "From your phone or tablet",
          "ADD_SUCCESS": "Picture added successfully",
          "REMOVE_SUCCESS": "Picture removed successfully",
          "PICTURE_NAME_LABEL": "Picture-"
        },
        "ADD_DOCUMENT": {
          "TITLE": "Add supporting documents to the file",
          "INPUT_LABEL": "Add a document",
          "ADD_SUCCESS": "Document added successfully",
          "PARTIAL_UPLOAD": "Some documents could not be added. Check the selection and retry before sending the request.",
          "REMOVE_SUCCESS": "Document removed successfully",
          "DOCUMENT_NAME_LABEL": "Document-"
        },
        "MORE_INFO": {
          "TITLE": "Provide details to help process the request",
          "SUBTITLE": "Exact model, supplier reference, size, colour and any other useful details",
          "INPUT_LABEL": "Example: the zipper has torn all the seams",
          "READ_CONFIRMATION": "I have included all this information"
        }
      },
      "MESSAGE": {
        "SENT_SUCCESS": "Request sent successfully",
        "PARTIAL_SUCCESS": "File saved successfully"
      },
      "BUTTON": { "VALIDATE": "Validate the preliminary request" },
      "MODAL": {
        "TITLE": "Preliminary support request to the repairer",
        "PROSPECT_PDF_LABEL": "Support request",
        "TITLE_EMAIL": "Send the request to the repairer by email",
        "PLACEHOLDER_EMAIL": "Repairer email address",
        "INFORMATION": "All documents and comments will be sent to the repairer for a complete diagnosis.",
        "VALIDATION_BUTTON": "Send to the repairer",
        "BOTTOM_TEXT": "The file will be saved while awaiting the repairer's response."
      }
    },
    "SUB_STEP_PROSPECT_RESPONSE": {
      "WAITING": "Request sent. Awaiting the manufacturer's response. You can also enter a response received directly.",
      "RESPONSE_RECEIVED": "Check and validate the manufacturer's response before continuing.",
      "REFRESH": "Refresh response",
      "REFRESH_TITLE": "Refresh the manufacturer's response?",
      "REFRESH_MESSAGE": "Your unsaved response changes will be replaced by the saved response.",
      "COMPUTER_SUBTITLE": "Add a file from this computer.",
      "TITLE": "Manufacturer response to the support request",
      "PLACEHOLDER": {
        "SUPPORT_NUMBER": "Enter the support request number",
        "COMMENT": "Describe the manufacturer's response and any useful instructions for the store"
      },
      "MANUFACTURER_SUPPORT_LABEL": "Manufacturer decision",
      "MANUFACTURER_OPTION": {
        "PRODUCT_REPAIR_WITH_GUARANTEE": "Repair under warranty",
        "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Return the product for diagnosis",
        "CREDIT_OR_REFUND": "Credit / refund",
        "PRODUCT_REPLACEMENT": "Replace with a new product",
        "TECHNICIAN_ON_SITE_INTERVENTION": "On-site technician intervention",
        "REJECT_PROSPECT": "Reject repair and close the file",
        "OTHER": "Other"
      },
      "MESSAGE": { "VALIDATE_SUCCESS": "Manufacturer response saved" },
      "MODAL": {
        "TITLE": "Confirm the manufacturer's response",
        "MESSAGE": "Confirmation triggers actions on the file and cannot be undone."
      }
    }
  },
  "PUBLIC_PROSPECT": {
    "SUPPORT_NUMBER_LABEL": "Support request number",
    "MANUFACTURER_COMMENT_LABEL": "Comment",
    "MANUFACTURER_ATTACHMENT_LABEL": "Add an attachment"
  },
  "RENTAL_FILE_CREATE": {
    "LOAD_ERROR": "Unable to load the rental form. Please try again.",
    "DATE_ERROR": "Select a valid delivery date, today or later.",
    "SAME_BILLING_ADDRESS": "Billing address is the same as the delivery address",
    "SECTIONS": {
      "DELIVERY_ADDRESS": "Delivery address",
      "BILLING_ADDRESS": "Billing address",
      "DELIVERY_DEPOSIT": "Delivery and deposit",
      "ADDITIONAL_INFORMATION": "Additional information"
    }
  },
  "RENTAL_MODULE_CREATE_FILE_PAGE": {
    "NEXT_STEP_CARD": {
      "TITLE": "Next steps to confirm the rental request",
      "P1": "1. Complete the form and submit the rental request",
      "P2": "2. Within one hour, the customer receives the contract by email via WeSign and the deposit request by email and phone via Swikly (unless the store manages the deposit)",
      "P3": "3. The machine is shipped to the requested delivery address and date*, once the contract is signed and the deposit confirmed",
      "P3_DOT": "*Requests processed before 11 a.m. are delivered the next day; requests processed after 11 a.m. are delivered two days later",
      "P4": "4. The customer receives and uses the machine while their equipment is being repaired",
      "P5": "5. Once the equipment is repaired, the store informs the customer. The customer has 48 hours to return the rental machine to the store",
      "SP2": "Additional contractual charges",
      "SP2_1": "After 48 hours, an additional €29 per day will be charged",
      "SP2_2": "A €29 cleaning fee may apply if the machine is not returned in its original condition",
      "P6": "6. The store ships the machine back to Boomerang",
      "P7": "7. The machine is inspected and the deposit released by Boomerang"
    },
    "FORM": {
      "TITLE": "Rental contract form",
      "COMPANY_NAME_LABEL": "Company name",
      "CLIENT_FULLNAME_LABEL": "Contract signatory's name",
      "CLIENT_EMAIL_LABEL": "Contract signatory's email",
      "CLIENT_PHONE_NUMBER_LABEL": "Signatory's phone number",
      "DESIRED_DELIVERY_DATE_LABEL": "Requested delivery date",
      "DEPOSIT_LABEL": "Deposit management",
      "DEPOSIT_VALUE_1_LABEL": "Deposit managed by the distributor on the customer's account",
      "DEPOSIT_VALUE_2_LABEL": "Online deposit via Boomerang and its partner Swikly (maximum €4.50 processing fee)",
      "COMMENT_LABEL": "Comment",
      "COMMENT_PLACEHOLDER": "Additional information (e.g. the customer will not be present at the workshop)",
      "CARD_LABEL": "General terms of short-term rental",
      "VALIDATION": "Submit the rental request"
    }
  },
  "RENTAL_PRODUCT_DETAIL": {
    "TITLE": "Rental product details",
    "SERIAL_NUMBER": "Serial number: {number}",
    "RENTAL_PRICE": "Rental price excl. VAT",
    "PRODUCT_SHEET": "Product information",
    "SPECIFICATIONS": "Specifications",
    "CONSUMABLE_REFERENCE": "Ref. {reference}",
    "CONTRACT_DETAILS_HINT": "Contract details will be requested when you create the rental file.",
    "FIELDS": {
      "BRAND": "Brand",
      "CATEGORY": "Range",
      "MODEL": "Model",
      "REFERENCE": "Reference",
      "SUB_CATEGORY": "Subcategory",
      "WEIGHT": "Weight",
      "LENGTH": "Length",
      "WIDTH": "Width"
    },
    "NO_PICTURE": "Product photo unavailable",
    "CONSUMABLE_PICTURE": "Consumable photo"
  },
  "RENTAL_MODULE_PRODUCT_DETAIL_PAGE": {
    "DEPOSIT": "Deposit",
    "CONSUMABLE_TEXT": "Remember to offer these consumables",
    "SUMMARY_TEXT": "Request a rental contract",
    "HT_PRICE": "Subtotal",
    "DELIVERY_TOTAL": "Delivery from",
    "FREE_DELIVERY": "FREE",
    "HT_TOTAL": "Total excl. VAT",
    "CREATE_RENT_BUTTON": "Create a rental contract"
  },
  "RENTAL_FILE_WELCOME": {
    "TITLE": "Welcome to Boomerang rental",
    "SUBTITLE": "Discover our selection of power tools for rent, ideal for keeping you equipped while your own equipment is being repaired.",
    "EMPTY": "No products match your search and selected availability filters.",
    "LOAD_ERROR": "Unable to load rental products. Please try again.",
    "FIND_PRODUCT": "Find your product",
    "SELECT_ALL": "View all",
    "AVAILABILITY_STATUS_GROUP": "Availability",
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Available",
      "IN_COMING": "Coming soon",
      "UNAVAILABLE": "Unavailable"
    },
    "AVAILABILITY_ERROR": "You cannot select an unavailable product"
  },
  "LOGIN_PAGE": {
    "TITLE": {
      "HEADER": "Sign in",
      "EMAIL": "Email",
      "PASSWORD": "Password",
      "COLLABORATOR": "Collaborator",
      "FIRSTNAME": "First name",
      "LASTNAME": "Last name",
      "TWO_FACTOR": "Two-step verification"
    },
    "BUTTON": {
      "SUBMIT": "Sign in",
      "SUBMIT_COLLABORATOR": "Sign in",
      "ADD_NEW_COLLABORATOR": "Add a collaborator",
      "ADD_COLLABORATOR": "Add collaborator",
      "HELP": "Need help?",
      "ADD_ACCOUNT": "Sign up",
      "REGISTRATION_PROMPT": "Don't have an account?",
      "FORGOT_PASSWORD": "Forgot password?",
      "RESET_PASSWORD": "Reset it",
      "VERIFY_TWO_FACTOR": "Verify code",
      "RESEND_TWO_FACTOR": "Resend code"
    },
    "INPUT": {
      "SELECT_COLLABORATOR": "Select a collaborator",
      "ADD_COLLABORATOR": "Create collaborator",
      "EMAIL_PLACEHOLDER": "Enter your email",
      "PASSWORD_PLACEHOLDER": "Enter your password",
      "TWO_FACTOR_CODE": "Verification code received by email"
    },
    "MESSAGE": {
      "SUCCESS": "Signed in",
      "ERROR": "Invalid credentials",
      "NO_COLLABORATOR": "No collaborator is available for this account",
      "TWO_FACTOR_SENT": "A verification code has been sent by email"
    }
  },
  "LOGIN_ADD_COLLABORATOR": {
    "MESSAGE": {
      "SUCCESS": "The collaborator was added successfully",
      "ERROR": "Unable to add the collaborator"
    }
  },
  "LOGIN_FORGOT_PASSWORD": {
    "TITLE": {
      "HEADER": "Forgot password",
      "EMAIL": "Email"
    },
    "BUTTON": {
      "SUBMIT": "Send"
    },
    "MESSAGE": {
      "SUCCESS": "A reset email has been sent",
      "ERROR": {
        "CAPTCHA": "Invalid captcha"
      }
    }
  },
  "LOGIN_REGISTER": {
    "TITLE": {
      "HEADER": "Registration form",
      "LASTNAME": "Last name",
      "FIRSTNAME": "First name",
      "EMAIL": "Email",
      "PHONE_NUMBER": {
        "TITLE": "Phone number",
        "LABEL": "Number",
        "COUNTRY": "Country"
      },
      "COMPANY_NAME": "Company name",
      "WHICH_MARKET": "Which store is concerned?",
      "JOB_DETAILS": "What is your job description?",
      "GEOGRAPHICAL": "Geographical area covered",
      "USER_JOB": "Role in the company",
      "MANAGER_EMAIL": "Manager email address",
      "CGU": "terms and conditions",
      "QUESTION_CGU": "I have read the",
      "CHIPS_MESSAGE": "others",
      "CHIP_MESSAGE": "other"
    },
    "BUTTON": {
      "NEXT": "Next",
      "SUBMIT": "Send request"
    },
    "MESSAGE": {
      "SUCCESS": "Registration request sent",
      "NO_DATA": "No data",
      "ERROR": {
        "CAPTCHA": "Invalid captcha",
        "TOS": "Accept the terms and conditions to continue",
        "502": "Unable to contact the server",
        "JOB_TYPE": "The specified job type is invalid"
      }
    },
    "SELECT_FIELD_TEXT": {
      "ROLE": "Select a company role",
      "GEOGRAPHICAL_ZONE": "Select a geographical area"
    }
  },
  "RESET_PASSWORD": {
    "TITLE": "Reset your password",
    "PASSWORD": "Password",
    "CONFIRM_PASSWORD": "Confirm password",
    "PASSWORD_PLACEHOLDER": "Enter your password",
    "CONFIRM_PASSWORD_PLACEHOLDER": "Confirm your password",
    "SUCCESS": "Password updated successfully",
    "ERROR": "We could not validate your request because it expired after 60 minutes. Please submit another password reset request.",
    "BUTTON": {
      "SUBMIT": "Update"
    }
  },
  "INIT_PASSWORD": {
    "TITLE": "Set your password",
    "PASSWORD": "New password",
    "CONFIRM_PASSWORD": "Confirm your password",
    "PASSWORD_PLACEHOLDER": "Enter your password",
    "CONFIRM_PASSWORD_PLACEHOLDER": "Confirm your password",
    "SUCCESS": "Password created successfully",
    "ERROR": "We could not validate your request because it expired after 7 days. Please submit another password reset request.",
    "BUTTON": {
      "SUBMIT": "Update"
    }
  },
  "PROFILE_PAGE": {
    "TITLE": {
      "HEADER": "Edit profile",
      "SUBTITLE": "Manage your personal information, password and collaborators."
    },
    "TABS": {
      "PERSONAL_INFORMATION": "Personal information",
      "PASSWORD": "Password",
      "COLLABORATORS": "Collaborators"
    },
    "SEARCH_COLLABORATORS": "Search collaborator",
    "FORM": {
      "PERSONAL_INFO": "Personal information",
      "LABEL_LASTNAME": "Last name",
      "LABEL_FIRSTNAME": "First name",
      "LABEL_PHONE": "Phone",
      "LABEL_EMAIL_LOGIN": "Login email",
      "CONNECTION_INFO": "Connection information",
      "LABEL_CURRENT_PASSWORD": "Current password",
      "LABEL_NEW_PASSWORD": "New password",
      "LABEL_CONFIRM_PASSWORD": "Confirm password"
    },
    "PLACEHOLDERS": {
      "PHONE": "Phone",
      "CURRENT_PASSWORD": "Current password",
      "NEW_PASSWORD": "New password",
      "CONFIRM_PASSWORD": "Confirm password"
    },
    "TABLE": {
      "COLLABORATORS": "Collaborators",
      "LASTNAME": "Last name",
      "FIRSTNAME": "First name",
      "JOB_DESCRIPTION": "Job",
      "STATUS": "Status",
      "LOADING_COLLABORATOR": "Loading collaborators...",
      "NO_COLLABORATOR": "No collaborator",
      "NO_JOB_DESCRIPTION": "Not provided"
    },
    "STATUS": {
      "active": "Active",
      "inactive": "Inactive",
      "deleted": "Deleted",
      "pending": "Pending"
    },
    "DIALOGUE": {
      "TITLE": "Delete collaborator",
      "MESSAGE": "Do you really want to delete {collaborator}?",
      "WARNING": "This action is irreversible."
    },
    "BUTTON": {
      "ADD_COLLABORATOR": "Create collaborator",
      "UPDATE_COLLABORATOR": "Update collaborator",
      "VALIDATE": "Validate",
      "VALIDATE_PASSWORD": "Validate password"
    },
    "MESSAGE": {
      "SUCCESS": "Profile updated",
      "SUCCESS_ACTIVE": "Collaborator activated",
      "SUCCESS_INACTIVE": "Collaborator deleted",
      "ERROR": "Unable to update profile",
      "ERROR_PASSWORD": "Incorrect password"
    }
  },
  "CREATE_COLLABORATOR": {
    "TITLE": {
      "HEADER": "Create collaborator",
      "SUBTITLE": "Collaborator creation form"
    },
    "PERSONAL_INFO": "Personal information",
    "FIRSTNAME": "First name",
    "LASTNAME": "Last name",
    "JOB_DESCRIPTION": "Job",
    "BUTTON": {
      "CREATE": "Add"
    },
    "ERROR": {
      "USER_EXIST": "User already exists"
    }
  },
  "CREATE_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Add collaborator",
      "SUBTITLE": "Add collaborator form"
    },
    "FORM": {
      "PERSONAL_INFO": "Personal information",
      "LABEL_LASTNAME": "Last name",
      "LABEL_FIRSTNAME": "First name",
      "LABEL_JOB_DESCRIPTION": "Job"
    },
    "BUTTON": { "VALIDATE": "Confirm collaborator addition" },
    "MESSAGE": { "SUCCESS": "Collaborator added successfully" },
    "PLACEHOLDER": {
      "LASTNAME": "E.g. Smith",
      "FIRSTNAME": "E.g. Marie",
      "JOB_DESCRIPTION": "Describe useful information"
    }
  },
  "EDIT_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Edit collaborator",
      "SUBTITLE": "Edit collaborator form"
    },
    "FORM": {
      "PERSONAL_INFO": "Personal information",
      "LABEL_LASTNAME": "Last name",
      "LABEL_FIRSTNAME": "First name",
      "LABEL_JOB_DESCRIPTION": "Job",
      "LABEL_STATUS": "Status"
    },
    "BUTTON": { "VALIDATE": "Confirm collaborator changes" },
    "MESSAGE": { "SUCCESS": "Collaborator updated successfully" },
    "PLACEHOLDER": {
      "LASTNAME": "E.g. Smith",
      "FIRSTNAME": "E.g. Marie",
      "JOB_DESCRIPTION": "Describe useful information"
    }
  },
  "EDIT_COLLABORATOR": {
    "TITLE": {
      "HEADER": "Edit collaborator",
      "SUBTITLE": "Update collaborator information."
    },
    "PERSONAL_INFO": "Personal information",
    "FIRSTNAME": "First name",
    "LASTNAME": "Last name",
    "JOB_DESCRIPTION": "Job",
    "BUTTON": {
      "UPDATE": "Validate"
    },
    "ERROR": {
      "NO_COLLABORATOR": "The collaborator does not exist",
      "USER_EXIST": "User already exists"
    },
    "SUCCESS": "Collaborator updated"
  },
  "ERROR_STATUS_CODE_MESSAGE": {
    "200": "Request successful",
    "400": "Invalid request",
    "401": "Your session has expired. Please sign in again.",
    "403": "Unauthorized action",
    "404": "Page not found",
    "405": "Unknown request",
    "413": "File too large",
    "500": "Internal server error",
    "502": "Network error",
    "504": "Request timed out",
    "524": "Processing took too long and was interrupted.",
    "NOT_REDIRECT": "Unable to redirect",
    "UNKNOWN": "An unknown error occurred"
  },
  "ERROR": {
    "PACKAGE_CODE_ADJUSTMENT_DISABLED_ERROR": "Package code adjustments are disabled for this store. Reload the pricing step.",
    "SMS_NOTIFICATION_FAILED_ERROR": "The SMS could not be sent. Please try again.",
    "SMS_SERVICE_UNAVAILABLE_ERROR": "SMS notifications are unavailable. Please try again later or choose another notification method.",
    "INVALID_RENTAL_FILE_PRODUCT_AVAILABILITY_ERROR": "This product is no longer available for rental. Please select another product.",
    "TNT_NO_TERMINAL_EVENT": "No final TNT event was received.",
    "TNT_SHIPMENT_FAILED": "TNT shipment generation failed.",
    "INVALID_CAPTCHA_TOKEN_ERROR": "Invalid reCAPTCHA token.",
    "LOGIN_2FA_REQUIRED_ERROR": "Two-step verification required.",
    "INVALID_LOGIN_2FA_CODE_ERROR": "Invalid verification code.",
    "EXPIRED_LOGIN_2FA_CODE_ERROR": "Verification code expired.",
    "LOGIN_2FA_ATTEMPT_LIMIT_REACHED_ERROR": "Too many verification attempts. Please sign in again.",
    "LOGIN_2FA_RESEND_LIMIT_REACHED_ERROR": "Please resend the code later."
  },
  "DISCONNECT": {
    "MESSAGE": "You have been signed out"
  },
  "JOB_LIST": {
    "STORE_SALESMAN_JOB": "Store salesperson",
    "TELEPHONE_SALESMAN_JOB": "Telephone salesperson",
    "TRAVELING_SALESMAN_JOB": "Traveling salesperson",
    "STORE_MANAGER_JOB": "Store manager",
    "GEOGRAPHIC_MANAGER_JOB": "Geographic manager",
    "RSE_DEPARTMENT_JOB": "CSR department",
    "MARKETING_DEPARTMENT_JOB": "Marketing department",
    "PURCHASING_DEPARTMENT_JOB": "Purchasing/Operations department",
    "OTHER_JOB": "Other"
  },
  "welcome": "welcome",
  "FILE_STEP_TRANSPORT_MODALITY": {
    "UI": {
      "ADDRESS_SUBTITLE": "Select a transport mode and confirm the departure and return addresses.",
      "TRANSPORT_SUBTITLE": "Select the equipment and a transport option.",
      "MATERIAL_SUBTITLE": "Select the items included in your parcel. Adjust quantities if needed.",
      "CHOICE_TITLE": "Choose the transporter",
      "CHOICE_SUBTITLE": "Available options depend on the declared material and package dimensions.",
      "PACKAGE": "Package details (automatic calculation)",
      "BATTERY": "Battery",
      "PALLET": "Pallet",
      "SPECIFIC_TRANSPORT": "Specific transport (freight)",
      "OWN_TRANSPORT": "Arrange transport independently",
      "CONFIRM_INFORMATION": "Confirm information",
      "EDIT_ADDRESS": "Edit address",
      "ADDRESS_FLOW": {
        "DEPARTURE": "Departure",
        "REPAIR": "Repair",
        "RETURN": "Return"
      },
      "LOAD_ERROR": "Unable to load transport information.",
      "INIT_ERROR": {
        "ELIGIBILITY": "Unable to load the store's transport eligibility settings. Retry or contact support if the problem persists.",
        "MANUFACTURERS": "Unable to load the manufacturers covered by the store's transport support settings. Retry or contact support if the problem persists.",
        "ALTERNATIVES": "Unable to load the alternative repairers available for this repair file. Retry or contact support if the problem persists.",
        "PRODUCTS": "Unable to load the product and materials to transport. Retry or contact support if the problem persists.",
        "STATE": "Unable to restore the transport form from the repair file and selected store. Retry or contact support if the problem persists."
      },
      "INIT_DIAGNOSTIC": {
        "SOURCES": {
          "ELIGIBILITY": "Failed to read the store's transport support settings",
          "MILWAUKEE_MANUFACTURERS": "Failed to load the Milwaukee transport-support manufacturer list",
          "GUARANTEE_MANUFACTURERS": "Failed to load the store's under-warranty transport manufacturer list",
          "WITHOUT_GUARANTEE_MANUFACTURERS": "Failed to load the store's out-of-warranty transport manufacturer list",
          "ALTERNATIVES": "Failed to resolve the store's alternative repairers",
          "PRODUCTS": "Failed to load the selected product and its associated materials",
          "STATE": "Failed to restore the transport form"
        },
        "FIELDS": {
          "repairFile": "Repair file",
          "store": "Store",
          "network": "Network",
          "manufacturer": "Manufacturer",
          "product": "Product",
          "warranty": "Warranty"
        },
        "CAUSES": {
          "SESSION": "Your session is no longer valid. Sign in again.",
          "ACCESS": "Access to this information was denied. Ask your administrator to check your permissions.",
          "TIMEOUT": "The service did not respond in time. Retry; this does not establish a configuration problem.",
          "NETWORK": "The application could not reach the service. Check your connection and retry.",
          "SERVICE": "The service failed to process this request. The response does not identify a missing configuration.",
          "NOT_FOUND": "The requested information could not be found. Check the references shown above.",
          "INVALID_DATA": "The information received could not be read or restored. Share the references above with support.",
          "UNKNOWN": "The cause could not be determined from the response. Share this diagnostic with support."
        },
        "CHECKS": {
          "ELIGIBILITY": "Where to check: the store's transport support settings (Milwaukee, under warranty and out of warranty). If they are correct, ask support to investigate loading these settings.",
          "MILWAUKEE_MANUFACTURERS": "Where to check: the manufacturer list for Milwaukee transport support. If the list is correct, ask support to investigate loading it.",
          "GUARANTEE_MANUFACTURERS": "Where to check: the store's manufacturer list for under-warranty transport support. If the list is correct, ask support to investigate loading it.",
          "WITHOUT_GUARANTEE_MANUFACTURERS": "Where to check: the store's manufacturer list for out-of-warranty transport support. If the list is correct, ask support to investigate loading it.",
          "ALTERNATIVES": "Where to check: the store's alternative-repairer setting and assigned repairers, then their routing configurations in this network and warranty coverage. These routes do not require manufacturer, category or subcategory matching.",
          "PRODUCTS": "Where to check: the selected product reference, its availability for this network/store, and its associated materials. If correct, ask support to investigate loading the product list.",
          "STATE": "Where to check: the selected store and the repair file's saved transport modality, addresses and product selection. Ask support to investigate restoration; do not delete the repair file."
        },
        "ALTERNATIVES": {
          "STORE_MISSING": "The repair file's store could not be found.",
          "DISABLED": "Alternative repairers are not enabled for this store.",
          "NO_REPAIRERS": "No alternative repairer is assigned to this store.",
          "NO_NETWORK_CONFIGURATION": "No repairer routing configuration exists in the authorized network.",
          "NO_MATCH": "No routing configuration in this network links an assigned alternative repairer with the required warranty coverage.",
          "ENABLE": "No store/warranty condition is missing on this configuration; check that alternative repairers are enabled for the store."
        },
        "CONDITIONS": {
          "store": "repairer assigned as an alternative for this store",
          "warranty": "required warranty coverage"
        },
        "REFERENCE": "Support reference: {reference}"
      },
      "CONTEXT_ERROR": "Unable to load the repairer's configuration.",
      "ROUTING_DIAGNOSTIC": {
        "TITLE": "No official repairer configuration matches this repair file.",
        "FIELDS": {
          "manufacturer": "Manufacturer",
          "category": "Category",
          "subcategory": "Subcategory",
          "store": "Store",
          "warranty": "Warranty support"
        },
        "WARRANTY": {
          "without_guarantee": "Non-warranty",
          "guarantee": "Under warranty"
        },
        "CANDIDATES": "Closest configurations in your network (an administrator must confirm the intended repairer):",
        "MISSING": "unmet conditions: {conditions}.",
        "LIMIT": "Only the first 5 of {count} closest configurations are displayed.",
        "NO_CANDIDATES": "No configuration associated with this manufacturer, category or subcategory was found in your network.",
        "NO_CONFIGURATION": "No repairer configuration exists for your network.",
        "ACTION": "An administrator must confirm the intended repairer and correct its associations or warranty support. Exactly one configuration must satisfy all conditions above. No repairer has been selected automatically."
      },
      "CARRIER_ERROR": "Unable to load available transporters.",
      "ADD_MATERIAL": "Add: {name}",
      "REMOVE_MATERIAL": "Remove: {name}"
    },
    "TEMPORARY_MESSAGE": { "CONFIRMATION_BUTTON": "I understand" },
    "TITLE": "Transport",
    "SUB_TITLE": {
      "ADDRESS_INFORMATION": "Address information",
      "TRANSPORTER_INFORMATION": "Transport selection"
    },
    "SELECT": {
      "MODALITY_TYPE": {
        "TITLE": "Transport mode",
        "TRANSPORTER": "Send to the manufacturer/official repairer",
        "IMPOSSIBLE_ERP_WARNING": "To repair this product with this manufacturer, your store must have an ACTIVE ACCOUNT NUMBER with this repairer.\nTo find an alternative repairer, contact BOOMERANG at support{'@'}boomerang-exploration.com",
        "ALTERNATIVE_TRANSPORTER": "Send to your local repairer (only if YOU KNOW they repair this brand)",
        "ALTERNATIVE_TRANSPORTER_TITLE": "Select a local repairer",
        "WORKSHOP": "Deliver directly to the repairer",
        "STORE": "Repair / Management by the store",
        "EXCLUDING_SUPPORT": "Outside the process"
      },
      "ADDRESS": { "TITLE": "Enter the addresses" }
    },
    "CARD_STEP_ONE": {
      "TITLE": {
        "SEND_FROM": "Departure address",
        "SEND_TO": "Repairer",
        "RECEIVE_TO": "Return address"
      },
      "NAME": "Address name",
      "ADDRESS": "Address",
      "COMPLEMENT_ONE": "Address line 2",
      "ZIP_CODE": "Zip code City",
      "CONTACT_NAME": "Contact name",
      "CONTACT_EMAIL": "Email",
      "CONTACT_PHONE": "Phone"
    },
    "CARD_STEP_TWO": {
      "BATTERY": "Battery of ",
      "WATT_HOUR": "Wh",
      "EXPRESS": "Freight transport required"
    },
    "CARD_TRANSPORTER": {
      "TITLE": "{transporter} pickup and tracking",
      "TITLE_WHITE_LIST": "Unavailable",
      "TYPE": "Express carrier",
      "OPERATOR_MARKET": "Managed by the store",
      "NO_TRANSPORTER": "No transporter found"
    },
    "CARD_CUSTOMER_SERVICE": {
      "TYPE": "Use this option when Chronopost cannot handle the shipment, for example because of non-standard dimensions.",
      "TYPE_BOOMERANG": "The manufacturer requires a specific process. Select this option so your head office or partner can arrange it and share the appropriate shipping label."
    },
    "CARD_WITHOUT_TRANSPORTER": {
      "TYPE": "No logistics tracking by the Boomerang team."
    },
    "CHRONOPOST_CONFIRMATION": {
      "CARD_NOTICE": "Please comply with the conditions below",
      "TITLE": "I CONFIRM that the BOX/PARCEL meets these 4 CONDITIONS:",
      "LINE_1": "1. The parcel does not exceed {maxLength} in length",
      "LINE_2": "2. The girth does not exceed 300 cm. Girth = Width + 2 × Length + 2 × Height",
      "LINE_3": "3. The parcel weighs LESS THAN {maxWeight}",
      "LINE_4": "4. The product is not on a PALLET"
    },
    "SELECT_MATERIAL": {
      "TITLE": "Material to declare",
      "WEIGHT": "Weight",
      "BIGGEST_WIDTH": "Width (cm)",
      "BIGGEST_LENGTH": "Length (cm)",
      "KILOGRAM": "kg",
      "CENTIMETER": "cm"
    },
    "PLACEHOLDER": {
      "MODALITY_TYPE": "Select a mode",
      "ALTERNATIVE_REPAIRER": "Alternative repairer(s)"
    },
    "BUTTON": { "NEXT": "Next step", "VALIDATION": "Schedule shipment" },
    "MODAL": {
      "ADDRESS": {
        "TITLE": {
          "SEND_FROM": "Edit departure address",
          "SEND_TO": "Repairer address",
          "RECEIVE_TO": "Edit return address"
        },
        "NAME": "Address name",
        "NUMBER": "No.",
        "STREET": "Street",
        "COMPLEMENT_ONE": "Address line 2",
        "ZIP_CODE": "Zip code",
        "CITY": "City",
        "CONTACT_NAME": "Contact name",
        "CONTACT_EMAIL": "Email",
        "CONTACT_PHONE": "Phone",
        "VALIDATION_BUTTON": "Save address"
      },
      "BATTERY": {
        "TITLE": "Battery specifications",
        "MESSAGE": "Damaged lithium batteries can short-circuit during transport, causing overheating or fire.\n\nThe shipper is responsible for the transport and any resulting costs in the event of an accident. Dangerous goods must be correctly declared, packed, labeled, and accompanied by the required documentation.\n\nBatteries rated at 100 Wh or more are not accepted by express carriers (TNT, Chronopost, or UPS). They must be sent by freight transport and declared and labeled accordingly. The label is available at the end of this process.",
        "TEXT_INPUT": {
          "VOLTAGE": "Battery voltage",
          "AMPERAGE": "Battery current",
          "CHECKBOX": "Special cases:\nDEWALT: I confirm that I installed the required cover on the FLEXVOLT battery so it can be sent by express transport.\nFESTOOL: I confirm that I switched the POWERSTATION to OFF so it can be sent by express transport."
        },
        "EXPRESS": { "YES": "Express transport allowed", "NO": "Freight transport required" },
        "PLACEHOLDER": { "VOLTAGE": "18 V", "AMPERAGE": "8 Ah" }
      },
      "MANUFACTURER_TRANSPORTER": {
        "TITLE": "Request transport from the repairer's customer service",
        "SUB_TITLE": "Email a transport request to the repairer:",
        "FILE_INPUT": { "ORDER": "Repair order", "PACKAGE": "Customer service sheet" },
        "INFORMATION": {
          "TITLE": "Additional information",
          "NUMBER": "Repairer's customer service contact",
          "ERP_REPAIRER_NUMBER": "Your customer number",
          "INTERNAL_COMMAND_NUMBER": "Your order number"
        },
        "VALIDATION_BUTTON": "Send and complete the file",
        "BOTTOM_TEXT": "After this request, the file will be saved while awaiting the transport label",
        "BOTTOM_TEXT_PARTNER": "Your partner will process the request and send the transport labels shortly.",
        "BOTTOM_TEXT_ALERT_PREFIX": "If you have no update",
        "BOTTOM_TEXT_ALERT_SUFFIX": "within 48 hours, contact the team",
        "BOTTOM_TEXT_ALERT_TEAM": "BOOMERANG",
        "MESSAGE": "Email sent successfully"
      }
    }
  },
  "CUSTOMER_SERVICE_TRANSPORT_PAGE": {
    "TITLE": "Customer service transport request",
    "SUBTITLE": "Enter the information needed to arrange pickup",
    "TRANSPORT_SUBTITLE": "The repairer will use this information to arrange pickup and send you the transport documents.",
    "SUMMARY_TITLE": "Transport arranged by repairer customer service",
    "SUMMARY": "Transport request in preparation",
    "UNITS": { "CM": "cm" },
    "STEPS": {
      "STEP1": {
        "TITLE": "Pickup location and details",
        "SUBTITLE": "Select the location and check the contact and address."
      },
      "STEP2": {
        "TITLE": "Package information",
        "SUBTITLE": "Check the package dimensions and packaging."
      },
      "STEP3": {
        "TITLE": "Pickup availability",
        "SUBTITLE": "Enter the available days and time slots."
      }
    },
    "LOCATION": {
      "TITLE": "Pickup location",
      "SUBTITLE": "Select the location",
      "PLACEHOLDER": "Select the location",
      "CUSTOMER": "At the customer",
      "SITE": "At the store / center"
    },
    "CONTACT": {
      "LASTNAME": "Last name",
      "FIRSTNAME": "First name",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "ADDRESS_NAME": "Site name",
      "ADDRESS_NUMBER": "No.",
      "ADDRESS_STREET": "Street",
      "ADDRESS_COMPLEMENT_1": "Address complement 1",
      "ADDRESS_COMPLEMENT_2": "Address complement 2",
      "ZIP_CODE": "Zip code",
      "CITY": "City",
      "COUNTRY": "Country"
    },
    "PACKAGE": {
      "WEIGHT": "Weight (kg)",
      "LENGTH": "Length (cm)",
      "WIDTH": "Width (cm)",
      "HEIGHT": "Height (cm)",
      "PALLET": "Transport on a pallet"
    },
    "COMMENT": {
      "TITLE": "Transport comment",
      "PLACEHOLDER": "Specify the preferred pickup day(s), instructions for the driver, the specific product location..."
    },
    "RECIPIENT": {
      "TITLE": "Recipient customer service",
      "EMAIL": "Repairer email address",
      "PHONE": "Customer service phone",
      "ERP_NUMBER": "Your repairer customer number"
    },
    "SUMMARY_SECTIONS": {
      "LOCATION": "Pickup",
      "PICKUP_LOCATION": "Location",
      "CONTACT": "Contact",
      "ADDRESS": "Address",
      "CITY": "City",
      "PACKAGE": "Package",
      "DIMENSIONS": "Dimensions (L x W x H)",
      "COMMENT": "Comment"
    },
    "DOCUMENT": {
      "TITLE": "Documents",
      "PACKAGE": "Customer after-sales service form",
      "ORDER": "Repair order",
      "FILE_NAME": { "PACKAGE": "Customer_service_form", "ORDER": "Repair_order" }
    },
    "BUTTON": {
      "PREVIOUS": "Previous step",
      "BACK": "Back to transport options",
      "SUBMIT": "Send request"
    },
    "MESSAGE": { "SUCCESS": "Transport request sent" },
    "PLANNING": {
      "REMOVE_SLOT": "Remove slot",
      "DAY": {
        "MONDAY": "Monday",
        "TUESDAY": "Tuesday",
        "WEDNESDAY": "Wednesday",
        "THURSDAY": "Thursday",
        "FRIDAY": "Friday"
      },
      "ERROR": {
        "INVALID_RANGE": "The end time must be later than the start time.",
        "OVERLAP": "Time slots cannot overlap.",
        "MAX_SLOTS": "A maximum of two slots is allowed per day.",
        "REQUIRED": "Add at least one available time slot."
      }
    },
    "ERROR": {
      "LOAD": "Transport information could not be loaded. Try again before sending the request.",
      "POSITIVE_NUMBER": "Enter a strictly positive value."
    }
  },
  "hello": "hello",
  "LAYOUTS": {
    "DASHBOARD": "Home",
    "FOLDER": "Files",
    "USERS": "Users",
    "TRANSPORTER": "Transporters",
    "HELP": "Help",
    "LOGOUT": "Sign out",
    "NOTIFICATIONS": "Notifications",
    "PROFILE": "Collaborator",
    "RECYCLING_REPORT": "Performance report",
    "ENVIRONMENTAL_PERFORMANCE_REPORT": "Environmental performance analysis"
  },
  "USERS_PAGE": {
    "TITLE": "Users",
    "SUBTITLE": "List of users linked to your accessible stores.",
    "SEARCH": "Search a user",
    "ROLE_FILTER": "Role",
    "STATUS_FILTER": "Status",
    "DETAIL": {
      "TITLE": "User details",
      "SUB_HEADER": "User",
      "GENERAL_INFO": "General information",
      "USER_SCOPE": "User scope",
      "GROUP_NAME": "Group",
      "STORE_NAME": "Store",
      "SUBTITLES": {
        "COLLABORATORS": "List of collaborators linked to {accountEmail}",
        "GROUPS": "List of groups linked to {accountEmail}",
        "STORES": "List of stores linked to {accountEmail}"
      },
      "LOAD_ERROR": "Unable to load this user.",
      "RETRY": "Retry",
      "ACCOUNT": "Account information",
      "ADDITIONAL": "Additional information",
      "COLLABORATORS": "Collaborators",
      "GROUPS": "Groups",
      "STORES": "Stores",
      "DEACTIVATE_CONFIRM": "Deactivate {collaborator}?",
      "FIELDS": {
        "ID": "ID",
        "EMAIL": "Login / Email",
        "APPLICANT_EMAIL": "Applicant email",
        "PHONE_NUMBER": "Phone number",
        "STATUS": "Status",
        "ROLE": "Roles",
        "NETWORK": "Network",
        "COLLABORATION_MODE": "Account structure",
        "REGION_CODE": "Area",
        "ACTIVATION_DATE": "Activation date",
        "FORMATION_ONE": "First training",
        "FORMATION_TWO": "Second training",
        "FORMATION_THREE": "Third training",
        "DESCRIPTION": "Description",
        "SUB_STATUS": "Sub-status"
      }
    },
    "EDIT": {
      "TITLE": "Edit user",
      "COLLABORATION_MODE": "Account mode",
      "SCOPE": "User scope",
      "SCOPE_NOTE": "Only your accessible stores and groups are shown. Other memberships are preserved.",
      "SOLO": "Single collaborator",
      "MULTIPLE": "Multiple collaborators",
      "SUCCESS": "User updated"
    },
    "TABLE": {
      "ROLE": "Role",
      "USER": "User",
      "APPLICANT": "Applicant",
      "FILES": "Files",
      "GROUPS": "Groups",
      "STATUS": "Status",
      "INFO_QUALITY": "Info quality",
      "DESCRIPTION": "Description",
      "OTHER": "other",
      "OTHERS": "others"
    },
    "STATUS": {
      "pending": "Pending",
      "inactive": "Inactive",
      "active": "Active",
      "deleted": "Deleted"
    },
    "INFO_QUALITY": {
      "missing": "Missing",
      "partial": "Partial",
      "complete": "Complete"
    }
  },
  "FINALIZATION_PAGE": {
    "RETURN_INVOICE_CONFIRMATION": "Warning! Have you checked that the repairer’s invoice is not in the parcel intended for your customer?",
    "TITLE": "Finalization of repair file No. {number}",
    "SUBTITLE": "Follow the 3 mandatory steps below to activate tracking for your repair. None can be skipped.",
    "SUBTITLE_WITHOUT_TRACKING": "Follow the 3 steps below to activate tracking for your repair.",
    "REPAIRER_NUMBER": "Repairer number",
    "REPAIRER_NUMBER_PLACEHOLDER": "Enter the number",
    "DOWNLOAD": "Download",
    "REDOWNLOAD": "Re-download",
    "TRACKING_NUMBER": "Tracking number",
    "TRACKING_NUMBER_PLACEHOLDER": "XR123456789FR",
    "FINISH_LATER": "Finish later",
    "ACTIVATE_TRACKING": "Activate repair-file tracking",
    "SECTIONS": {
      "TRANSPORT_DETAILS": "Enter transport information",
      "DOCUMENTS": "Print the documents for the repairer",
      "CLIENT_DOCUMENTS": "Print the documents for the customer",
      "CLIENT_DOCUMENTS_SUBTITLE": "These documents must be placed inside the parcel. Without them, your product cannot be handled.",
      "DOCUMENTS_SUBTITLE": "These documents must be placed inside the parcel. Without them, your product cannot be handled or repaired by the technician.",
      "ACTIVATE_TRACKING": "Activate repair-file tracking",
      "ACTIVATE_TRACKING_SUBTITLE": "By confirming, you declare that you have entered the tracking number and placed all documents inside the parcel. Tracking for your repair will then be activated.",
      "ACTIVATE_WITHOUT_TRACKING_SUBTITLE": "By confirming, you declare that you have placed all documents inside the parcel. Tracking for your repair will then be activated."
    },
    "DOCUMENTS_INCLUDED": {
      "DELIVERY_NOTE": "Delivery note",
      "REPAIR_ORDER": "Repair order",
      "GUARANTEE_EXTENSION_PROOF": "Guarantee extension proof",
      "PURCHASE_PROOF": "Purchase proof",
      "ASBESTOS_PROOF": "Asbestos proof",
      "FORCE_SUPPORT_PROOF": "Forced support proof",
      "BATTERY_LABEL": "Battery label",
      "TRANSPORT_LABEL": "Transport label",
      "TRANSPORTER_REPAIRER_DOCUMENT": "Transporter document for the repairer"
    },
    "DOCUMENT_PLACEMENTS": {
      "STICK_ON_PARCEL": "Stick on the parcel",
      "PUT_IN_PARCEL": "Put inside the parcel"
    },
    "MESSAGE": {
      "LOAD_ERROR": "The repair file or document list could not be loaded.",
      "SUCCESS": "Repair file finalized"
    }
  },
  "COMMON": {
    "MISSING_INFORMATION": "Missing information",
    "ORDER_NUMBER": "Order number",
    "COST": "Cost",
    "COST_EXCLUSIVE_TAX": "Cost (excl. tax)",
    "ADDRESS": {
      "STREET_ADDRESS": "Street address (number and street)",
      "ENTER_MANUALLY": "Enter address manually",
      "USE_AUTOCOMPLETE": "Use address autocomplete",
      "MISSING_NUMBER": "Add the street number to complete this address.",
      "COPY_TO_RETURN": "Also use these details for the return address",
      "GOOGLE_ATTRIBUTION": "Google Maps"
    },
    "AUTH_LINK": {
      "INVALID_TITLE": "Expired or invalid link",
      "INVALID_MESSAGE": "Use the link you received by email or request a new link from the sender."
    },
    "PUBLIC_PAGE": {
      "LOADING": "Loading…",
      "INVALID_TITLE": "Expired or invalid link",
      "INVALID_MESSAGE": "Request a new link or QR code from the file, or contact the sender.",
      "FAILED_TITLE": "Unable to load the page",
      "FAILED_MESSAGE": "The page could not be loaded. Check your connection and try again.",
      "RETRY": "Try again"
    },
    "ADDRESS_FIELDS": {
      "NAME": "Address name",
      "NUMBER": "Number",
      "STREET": "Street",
      "ZIP_CODE": "Postal code",
      "CITY": "City",
      "COUNTRY": "Country"
    },
    "REQUIRED": "Required",
    "UNITS": { "VOLT": "V", "AMPERE_HOUR": "Ah", "WATT_HOUR": "Wh" },
    "FILTER": {
      "SEARCH": "Search",
      "EXPORT": "Export",
      "SHOW_FILTERS": "Show filters"
    },
    "LOADING": "Loading...",
    "MESSAGE": {
      "ADD_ATTACHMENT_SUCCESS": "The attachment was added successfully.",
      "REMOVE_ATTACHMENT_SUCCESS": "The attachment was removed successfully."
    },
    "NO_DATA": "-",
    "CHOICE": { "YES": "Yes", "NO": "No" },
    "NO_VALUE": "-",
    "KILOGRAM": "kg",
    "CENTIMETER": "cm",
    "TONNE": "t",
    "INPUTS": {
      "OTHER_SELECTED": "+{count} other",
      "OTHERS_SELECTED": "+{count} others"
    },
    "NAVIGATION": {
      "DASHBOARD": "Home",
      "REPAIR_FILES": "Repair files",
      "USERS": "Users",
      "PROFILE": "Profile",
      "ENVIRONMENTAL_PERFORMANCE_REPORT": "Environmental performance analysis",
      "HELP": "Help",
      "LOGOUT": "Logout"
    },
    "BUTTON": {
      "YES": "Yes",
      "ADD": "Add",
      "SEND": "Send",
      "NO": "No",
      "BACK": "Back",
      "DETAIL": "Details",
      "UPDATE": "Update",
      "EDIT": "Edit",
      "DELETE": "Delete",
      "DEACTIVATE": "Deactivate",
      "CONTINUE": "Continue",
      "LEAVE": "Quit",
      "CANCEL": "Cancel",
      "VALIDATE": "Validate",
      "LOAD_MORE": "Load more",
      "REMOVE": "Remove",
      "SAVE": "Save",
      "CONFIRM": "Confirm",
      "CLOSE": "Close",
      "RETRY": "Retry"
    },
    "CREATION_IN_PROGRESS": "File creation in progress",
    "FILE_UPLOAD": {
      "DRAG_HERE": "Drag your file here",
      "OR": "or ",
      "BROWSE": "browse your files",
      "ACCEPTED_FORMATS": "Accepted formats: PDF, JPG, JPEG, PNG",
      "INVALID_FORMAT": "This file format is not accepted."
    },
    "STATUS_MACRO": {
      "DRAFT": "DRAFT",
      "IN_CREATION": "IN CREATION",
      "IN_CREATION_ESTIMATE": "IN CREATION - ESTIMATE",
      "IN_CREATION_PROSPECT": "IN CREATION - REQUEST",
      "TRANSPORT_GO": "OUTBOUND TRANSPORT",
      "RECEPTION_AT_REPAIRER": "RECEIVED BY REPAIRER",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "REPAIRER DIAGNOSTIC RECEIVED",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "REPAIRER DIAGNOSTIC PROCESSED",
      "ESTIMATE_SENT_TO_CUSTOMER": "CUSTOMER DECISION - ESTIMATE",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "REPAIRER ESTIMATE APPROVED",
      "IN_REPARATION": "REPAIR",
      "SENT_BACK_BY_REPAIRER": "RETURN TRANSPORT",
      "RECEIPT_AT_STORE": "RECEIVED AT STORE",
      "SENT_AVAILABLE_TO_CUSTOMER": "WAITING FOR COLLECTION",
      "TAKEOVER_BY_CUSTOMER": "CLOSED",
      "NETWORK_BILLING": "BILLING",
      "FINISHED": "FINISHED",
      "ABORT_BY_CUSTOMER": "ABORTED BY CUSTOMER",
      "DELETED": "DELETED"
    },
    "PRICING_TYPE": {
      "PACKAGE": "Package",
      "ESTIMATE": "Estimate"
    },
    "PRODUCT_TYPE": {
      "MACHINE": "Machine",
      "BATTERY": "Battery",
      "CHARGER": "Charger",
      "PRODUCT": "Product",
      "ACCESSORY_ONE": "Accessory 1",
      "ACCESSORY_TWO": "Accessory 2",
      "BRIEFCASE": "Case",
      "PREMIUM_CONSUMABLE": "Premium consumable",
      "PPE": "PPE",
      "EQUIPMENT": "Equipment",
      "PALLET": "Pallet"
    },
    "PRODUCT_END_STATUS": {
      "DEFAULT": "File closed without customer handover",
      "PRODUCT_REPAIRED": "Product repaired",
      "PRODUCT_REPLACED_STANDARD": "Standard replacement",
      "PRODUCT_REPLACED_SUPERIOR": "Upgrade replacement",
      "PRODUCT_CREDIT": "Credit note",
      "PRODUCT_RECYCLED": "Not repaired: recycling",
      "PRODUCT_RETURN_DISASSEMBLED": "Not repaired: returned disassembled",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Pre-approval: repair under warranty",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Pre-approval: repair outside warranty",
      "PROSPECT_CREDIT_OR_REFUND": "Pre-approval: credit or refund",
      "PROSPECT_REPLACEMENT": "Pre-approval: replacement",
      "PROSPECT_REJECT": "Pre-approval: support declined",
      "PROSPECT_OTHER": "Pre-approval: other"
    },
    "EURO": "€",
    "PERCENT": "%",
    "DATE_PLACEHOLDER": "DD/MM/YYYY",
    "EXCLUSIVE_TAX": "excl. tax",
    "DAY": "day",
    "DAYS": "days",
    "NOT_AUTHORIZED_ACTION_MESSAGE": "You are not authorized to perform this action. Please contact an administrator.",
    "GENERIC_EXPORT_SUCCESS": "The export has been generated and will be sent by email"
  },
  "RECYCLING_MODULE": {
    "RECYCLING_PAGE": {
      "TITLE": "Recycling",
      "SUBTITLE": "Track your recycled products, their buyback value and the fill level of your bins.",
      "GREEN": {
        "TITLE": "Recycling report",
        "TEXT_1": "Electrical and electronic equipment contains substances that can pollute the environment, but its materials also have significant recycling potential.",
        "TEXT_2": "The process is established with the eco-organizations responsible for portable batteries and accumulators, as well as WEEE recycling."
      },
      "MAIN": {
        "REPORT": {
          "RECYCLER": {
            "TITLE": "Number of recycled products"
          },
          "BUYBACK": {
            "TITLE": "Buyback value of recycled products"
          }
        },
        "BATTERIES": {
          "TITLE": "View the lithium packaging and storage procedure"
        },
        "RECYCLED_PRODUCT_LIST": {
          "TITLE": "Download the complete list of recycled products"
        },
        "TABLE": {
          "HEADER": {
            "NAME": "Name",
            "LOGO": "Logo",
            "FILLING": "Fill level"
          },
          "LOGO_ALT": "{name} logo",
          "BUTTON": "Request collection",
          "COLLECTION_TRIGGER_SUCCESS": "Your collection request has been sent. The partner will contact you shortly."
        }
      },
      "BUTTON": {
        "NEW_RECYCLING_FOLDER": "Recycle a product"
      }
    },
    "STEPPER": {
      "TITLE": "Professional equipment recycling",
      "SUBTITLE": {
        "PRODUCT_INFORMATION": "Identify the product to recycle and describe its condition.",
        "PRODUCT_CHECKING": "Check the buyback conditions before confirming the transfer.",
        "PRODUCT_PACKAGING": "Choose suitable product storage and confirm its transfer."
      },
      "ARIA_LABEL": "Recycling file creation steps",
      "LOAD_ERROR": "Unable to load recycling information.",
      "NO_FOLDER": "No folder created",
      "STEP": {
        "PRODUCT_INFORMATION": "Product information",
        "PRODUCT_CHECKING": "Checking",
        "PRODUCT_PACKAGING": "Storage conditions"
      }
    },
    "SUMMARY": {
      "PRODUCT_TITLE": "Selected product",
      "SOURCE_IMAGE": "Product photo",
      "CHECKING_TITLE": "Condition and buyback",
      "PRODUCT": "Product",
      "MANUFACTURER": "Brand",
      "SERIAL_NUMBER": "Serial number",
      "COMPANY": "Company",
      "CONDITION": "Condition",
      "BUYBACK_PRICE": "Buyback amount",
      "CLIENT_SHARE": "Amount paid to the customer",
      "STORE_SHARE": "Amount retained by the store"
    },
    "STEP_PRODUCT_INFORMATION": {
      "TITLE": "Register my product",
      "TITLE_CONDITION": "Product condition",
      "NO_PICTURE": "Select your product",
      "FORM": {
        "LABEL": {
          "COMPANY_NAME": "Company name",
          "DEPOSIT_DATE": "Deposit date",
          "MANUFACTURER": "Brand",
          "PRODUCT": "Find my product",
          "PRODUCT_NOT_FOUND": "My product is not listed",
          "ADD_PRODUCT_MESSAGE": "Think your product has value? Contact Boomerang via chat or on +33 6 69 51 56 64.",
          "SERIAL_NUMBER": "Serial number"
        },
        "PLACEHOLDER": {
          "COMPANY_NAME": "Your company",
          "MANUFACTURER": "Find my brand",
          "PRODUCT": "Find my product",
          "SERIAL_NUMBER": "999 999 999 999"
        }
      }
    },
    "STEP_PRODUCT_CHECKING": {
      "SUBTITLE": "Check the buyback conditions and how the amount is shared.",
      "RECYCLER": {
        "TITLE": "Condition check",
        "SUB_1": "This machine cannot be bought back…",
        "SUB_2": "But it still has value!",
        "TEXT_1": "Entrust it to us for responsible recycling.",
        "TEXT_2": "We will carefully sort its components: recovered raw materials will be reused or sent to our specialist partners for optimal recycling.",
        "TEXT_3": "Together, let's give materials a second life."
      },
      "RECONDITIONER": {
        "TITLE": "Condition check",
        "SUB_1": "Add product photos",
        "TEXT_1": "Add one photo so the provider can assess the product's buyback value.",
        "TEXT_2": "Take a photo of the identification plate.",
        "TEXT_3": "If there is no plate, take a photo of the machine laid flat.",
        "ADD_ATTACHMENT": {
          "INPUT_LABEL_BY_PC": "From your computer",
          "INPUT_LABEL_BY_QR_CODE": "From your phone or tablet",
          "REMOVE_SUCCESS": "Photo successfully removed",
          "PICTURE_NAME_LABEL": "Photo-"
        },
        "CGU_LABEL": "I understand that the buyback price is offered provided the machine is in the declared condition. A photo is attached to confirm the transfer and ensure equipment traceability."
      },
      "CONDITION_LABEL": "Condition",
      "BUYBACK_PRICE_LABEL": "Buyback",
      "BUYBACK_PRICE_CLIENT_LABEL": "Amount paid to the customer",
      "BUYBACK_PRICE_STORE_LABEL": "Amount retained by the store"
    },
    "STEP_PRODUCT_PACKAGING": {
      "TITLE": "Storage conditions",
      "SUBTITLE": "Prepare product storage and its transfer certificate.",
      "BATTERY_LABEL": "Battery presence",
      "BAC_DESIGNATION_LABEL": "Recycling bin",
      "DOWNLOAD_LINK_TEXT": "Download the product transfer certificate",
      "FORM": { "MAIL": "Send the certificate by email" },
      "PLACEHOLDER": { "MAIL": "Email address" },
      "BATTERY_WARNING": {
        "WITHOUT_BATTERY": "BATTERY HAZARD! I declare that no battery is recycled with this product (the store accepts responsibility).",
        "WITH_BATTERY": "BATTERY HAZARD! I am recycling a battery and comply with the storage conditions (the store accepts responsibility). See storage conditions."
      },
      "MODAL": {
        "TITLE": "Confirmation",
        "MESSAGE": "By confirming this step, you confirm that the customer has been informed of the immediate transfer of their product to your company. Your company becomes the owner and responsible party pending a future transfer to a third party."
      },
      "SUCCESS": "The file has been saved"
    },
    "RECYCLING_REPORT_PAGE": {
      "TITLE": "Environmental performance analysis",
      "SUBTITLE": "Avoided impact from your repairs, reuse and recycling, calculated with the LCA reference framework.",
      "GREEN": {
        "TITLE": "Your environmental performance report",
        "TEXT": "Because assessing a product’s value cannot be done alone, we brought together 5 companies to co-build a calculator based on field experience. Together, we defined a fair market reference framework aligned with operational realities. This living, evolving framework is enriched over time to guarantee increasingly precise estimates adapted to recycling and take-back challenges.",
        "DESCRIPTION": "Find all our sources:",
        "LINK_1": "Calculation reference framework",
        "LINK_2": "ADEME sources",
        "LINK_3": "Calculator methodology notes",
        "LINK_4": "LCA methodology notes"
      },
      "BUTTON": {
        "DOWNLOAD_REPORT": "Download report"
      },
      "MAIN": {
        "REPORT": {
          "WORLD_TOUR_TITLE": "Avoided world tours",
          "CO2": "Avoided CO2",
          "MATERIALS": "Unextracted raw materials"
        },
        "SELECT": {
          "STORE": "Select your store",
          "MANUFACTURER": "Select the brand"
        },
        "TABLE": {
          "HEADER": {
            "CURRENT_YEAR": "Current year",
            "LAST_YEAR": "Previous year",
            "TWO_YEAR": "2 years ago",
            "IMPACT_MATERIAL": "Material impact (kg) (year n-1)",
            "CO2_IMPACT": "CO2 impact (kg) (year n-1)"
          },
          "REPAIR_ROW": "Repair",
          "REPAIR_ECOSYSTEM_ROW": "Calculated and referenced via ACV ECOSYSTEM - BOOMERANG",
          "REPAIR_PROXY_ROW": "Studied via ADEME LCA proxy + other sources",
          "REPAIR_WITHOUT_ROW": "Without prior study",
          "REUSE_ROW": "Reuse",
          "REUSE_ECOSYSTEM_ROW": "Calculated and referenced via ACV ECOSYSTEM - BOOMERANG",
          "REUSE_PROXY_ROW": "Studied via ADEME LCA proxy + other sources",
          "REUSE_WITHOUT_ROW": "Without prior study",
          "RECYCLED_ROW": "Recycling",
          "RECYCLED_BY_BOOMERANG_ROW": "Via BOOMERANG",
          "RECYCLED_BY_REPAIRER_ROW": "Other",
          "RENTAL_ROW": "Rental",
          "WITHOUT_INFORMATION_ROW": "Without information",
          "TOTAL": "Total"
        }
      }
    }
  },
  "DASHBOARD": {
    "TITLE": "Welcome to Boomerang",
    "BUTTON": {
      "NEW_REPAIR_FILE": "New Repair / Service request file",
      "RECYCLE": "Recycle",
      "RECONDITION": "Recondition"
    },
    "FOOTER": {
      "AVERAGE_CUSTOMER": ">85%",
      "AVERAGE_RESPONSE": " automatic estimates",
      "GUARANTEE": "Up to 6 months Boomerang warranty",
      "PRODUCT_LABEL": "products",
      "MANUFACTURER_LABEL": "brands",
      "BUTTON": "Train on Boomerang with our teams"
    },
    "REPAIR_FILE_FINALIZED": {
      "TITLE": "Ecological Impact Calculator (in progress)",
      "CO2": "- CO²"
    }
  },
  "CURRENT_REPAIR_FILES": {
    "TITLE": "Current repair files",
    "SUBTITLE": "Track your current repair files",
    "SEE_MORE": "See more",
    "DOWNLOAD": "Download",
    "TABLE": {
      "REPAIR_FILE_BOOMERANG_ID": "File",
      "PRODUCT_NAME": "Product name",
      "COMPANY_NAME": "Company name",
      "MANUFACTURER_NAME": "Brand",
      "STATUS": "Status",
      "TIME": "Time",
      "MODALITY": "Support",
      "LOADING_REPAIR_FILES": "Loading current repair files...",
      "NO_REPAIR_FILE": "No current repair file"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporter",
      "WORKSHOP": "Workshop",
      "STORE": "Store"
    },
    "DAYS": "days"
  },
  "REPAIR_FILE_LIST_PAGE": {
    "TITLE": "Repair files",
    "SUBTITLE": "Track repair files linked to your operating center.",
    "SEARCH": "Search a repair file",
    "NEW_REPAIR_FILE": "New repair file",
    "FILTER": "Filter",
    "EXPORT": "Export",
    "EXPORT_REQUEST_SUCCESS": "The export generation request was successful. The file will be sent by email within a few minutes.",
    "EXPORT_REQUEST_FAILED": "The export generation request failed.",
    "DELETE_FILTER": "Clear filters",
    "TABLE": {
      "REPAIR_FILE_BOOMERANG_ID": "File",
      "STORE_NAME": "Store name",
      "COMPANY_NAME": "Company",
      "MANUFACTURER_NAME": "Brand",
      "PRODUCT_NAME": "Product",
      "RENTAL": "Rental",
      "STATUS": "Status",
      "TIME": "Time",
      "DATE": "Date",
      "MODALITY": "Support",
      "LOADING_REPAIR_FILES": "Loading repair files...",
      "NO_REPAIR_FILE": "No repair file"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporter",
      "WORKSHOP": "Workshop",
      "STORE": "Store",
      "EXCLUDING_SUPPORT": "Out of process"
    },
    "FILTERS": {
      "USER_ACTION": "Repair files requiring action",
      "CURRENT_FOLDER": "Current repair files only",
      "DATE_CREATION": "Creation date",
      "RENTAL": "With rental file only"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Select the brand",
      "STATUS_MACRO": "Select the status",
      "MODALITY": "Select the modality",
      "STORE": "Select store(s)",
      "REPAIR_CENTER": "Select the repair center"
    },
    "DAYS": "days",
    "DAY_WITH_COUNT": "{count} day",
    "DAYS_WITH_COUNT": "{count} days"
  },
  "ERROR_INPUT": {
    "SMS_MOBILE_NUMBER": "This phone number cannot receive the SMS notifying your customer. Enter a French mobile number starting with 06 or 07, or select the \"CALL\" option.",
    "PHONE_SMS_HINT": "Invalid number for sending SMS! Enter a French mobile number starting with 06 or 07...",
    "EMPTY": "This field is required",
    "MAX_FILES": "You can upload at most {max} files.",
    "MAX_LENGTH": "The maximum number of characters has been exceeded",
    "MIN_LENGTH": "This field must contain at least {min} characters",
    "EMAIL": {
      "EMPTY": "Email is required",
      "INVALID": "Enter a valid email",
      "MAX_LENGTH": "The maximum number of characters has been exceeded"
    },
    "PASSWORD": {
      "EMPTY": "Password is required",
      "ERROR_LENGTH": "Must contain at least 12 characters",
      "ERROR_UPPERCASE": "Must contain at least one uppercase letter",
      "ERROR_LOWERCASE": "Must contain at least one lowercase letter",
      "ERROR_DIGIT": "Must contain at least one digit",
      "ERROR_SPECIAL_CHAR": "Must contain at least one special character",
      "DIFFERENT_PASSWORD": "Passwords must match"
    }
  },
  "LEAVE_MODAL": {
    "SIMPLE_MODAL": {
      "TITLE": "Quit repair file creation?",
      "MESSAGE": "This draft repair file will be deleted. This action cannot be undone.",
      "VALIDATION_BUTTON": "Delete draft",
      "CANCEL_BUTTON": "Continue creation"
    },
    "STEPPER_MODAL": {
      "COUNT_1": "1/2",
      "COUNT_2": "2/2",
      "STEP_1": {
        "TITLE": "You are leaving this repair file",
        "SUBTITLE": "Choose whether to resume this repair file later or abandon it.",
        "VALIDATION_BUTTON": "Resume repair file creation later",
        "CANCEL_BUTTON": "Abandon repair file",
        "CANCEL_AND_RECYCLE_BUTTON": "Abandon repair file and/or RECYCLE"
      },
      "STEP_2": {
        "TITLE": "What is the reason?",
        "SUBTITLE": "The repair file will appear in the table with the Abandoned status.",
        "ABANDON_HELP": "Abandoning closes the repair file with the selected reason.",
        "DETAIL": "Reason details",
        "REASON": {
          "DEADLINE_TOO_LONG": "Deadline too long",
          "NO_PACKAGE": "No package",
          "OTHER": "Other",
          "REPAIR_TOO_EXPENSIVE": "Package too expensive, no immediate purchase",
          "REPAIR_TOO_EXPENSIVE_AND": {
            "BUY_SAME_BRAND": "same brand",
            "BUY_OTHER_BRAND": "another brand",
            "COMMON": "Repair too expensive, buying a product from the "
          }
        },
        "RECYCLING": {
          "TITLE": "Recycling/buyback solution",
          "BUYBACK_MESSAGE": "Buyback up to €{buybackPrice} depending on condition"
        },
        "SUBMIT": {
          "CANCEL": "Abandon repair file",
          "RECYCLING": "Offer recycling/buyback solution"
        }
      }
    }
  },
  "KEY_ACCOUNT_REPAIR_FILE_OPENING_WARNING": {
    "TITLE": "File initiated directly by the customer",
    "INTRO": "Please remember to:",
    "BILLING_REMINDER": "Invoice the service through your ERP.",
    "REFERENCE_REMINDER": "Use the references provided by the customer:",
    "CALLBACK_REF": "REF TO QUOTE:",
    "WORKSITE_CODE": "Worksite no.:",
    "DELIVERY_REMINDER": "Outbound transport is planned from the following address:",
    "ACKNOWLEDGEMENT": "I have taken these elements into account."
  },
  "REPAIR_FILE_DETAIL": {
    "INTERNAL_COMMAND_NUMBER": "No. ",
    "KEY_ACCOUNT_CREATED_BY_CUSTOMER_USER": "File created by a customer user",
    "MESSAGE": {
      "DELETE": {
        "SUCCESS": "The repair file was deleted successfully"
      },
      "STATUS_MACRO_UNKNOWN": "The repair file status is unknown",
      "NOT_FOUND": "The repair file was not found",
      "DRAFT": "This repair file is a draft",
      "DELETED": "This repair file has been deleted"
    },
    "HEADER_RENTAL": {
      "REPAIR": "Repair",
      "RENTAL": "Rental"
    },
    "MODAL": {
      "DELETE_REPAIR_FILE": {
        "TITLE": "Delete repair file",
        "MESSAGE": "Are you sure you want to delete this repair file?",
        "WARNING": "This action cannot be undone."
      }
    }
  },
  "REPAIR_FILE_DETAIL_ACTION_DRAWER": {
    "TITLE": "New action",
    "SUB_TITLE": {
      "CUSTOMER_SUPPORT": "Customer support"
    },
    "LAST_RELAUNCH": "Last follow-up: ",
    "CUSTOMER_ESTIMATE_REVISION": "Resume file",
    "REPAIRER_ESTIMATE": "Repairer estimate",
    "ADD_ESTIMATE_TO_FILE": "Add the repairer estimate to the file",
    "NOTIFY_THE_REPAIRER": "Resume the repairer estimate",
    "CLOSE_CASE": "Close file",
    "RETRIEVE_EQUIPMENT_CUSTOMER": "Close the file",
    "BUTTON": {
      "CONFIRM_COST": "Confirm cost/price without customer information",
      "ADD_RENTAL": "Add rental"
    }
  },
  "REPAIR_FILE_DELIVERY_CLIENT_DRAWER": {
    "UPDATE_TITLE": "Update file",
    "CLOSE_TITLE": "Close file",
    "SUB_TITLE": {
      "GUARANTEE_INFORMATION": "Information for the six-month warranty extension",
      "BILLING_NUMBER": "Supplier order number",
      "DELIVERY_INFORMATION": "Customer handover information",
      "BILLING_CLIENT_COST": "Amount invoiced to customer (excl. tax)",
      "DELIVERY_DATE": "Customer handover date",
      "REPAIR_CHANGE_COST": "Support",
      "TRANSPORT": "Transport",
      "MANAGEMENT": "Management",
      "REF_ERP": "ERP reference"
    },
    "DETAIL": {
      "DELIVERY_DATE_1": "Today's date is recorded automatically.",
      "DELIVERY_DATE_2": "Select another date if necessary."
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Product repaired",
      "PRODUCT_REPLACED_STANDARD": "Standard product replacement",
      "PRODUCT_REPLACED_SUPERIOR": "Upgrade product replacement",
      "PRODUCT_CREDIT": "Credit note",
      "PRODUCT_RECYCLED": "Not repaired: recycling",
      "PRODUCT_RETURN_DISASSEMBLED": "Not repaired: returned disassembled"
    },
    "SELECT": {
      "END_STATUS": "Select the final product status",
      "PRODUCT_BOOMERANG_NAME": "Product identifier",
      "SELECT_PRODUCT": "Select a product",
      "PRODUCT_END_COST": "Total invoiced by repairer (excl. tax)",
      "SERIAL_NUMBER": "Serial number",
      "TOTAL_HT": "Total excl. tax"
    },
    "PLACEHOLDER": {
      "END_STATUS": "Select the final product status",
      "PRODUCT": "Select the product",
      "SEARCH": "999 999 999 999",
      "PRODUCT_END_COST": "E.g. 49.90",
      "BILLING_NUMBER": "E.g. Supplier order number",
      "REPAIR_CHANGE_COST": "E.g. 49.90",
      "TRANSPORT": "E.g. 12.50",
      "MANAGEMENT": "E.g. 8.00"
    },
    "IMAGE": {
      "SERIAL_NUMBER_ALT": "Product serial number preview"
    },
    "BUTTON": {
      "SERIAL_NUMBER": "Find the serial number",
      "SAVE": "Save"
    },
    "MESSAGE": {
      "PRODUCT_BOOMERANG_ID_NOT_FOUND": "Your file is temporarily unavailable.",
      "PROLONGATION_GUARANTEE_FOUND": "This product serial number already has a warranty extension.",
      "GENERIC_SERIAL_NUMBER": "This serial number is generic, so the product will not receive an automatic warranty."
    }
  },
  "ESTIMATE_REPAIRER": {
    "TITLE": "Repairer estimate",
    "TITLE_CHOICE": "Customer choice",
    "ATTACHMENT": "Repairer estimate",
    "ATTACHMENT_ACTION": "Add estimate",
    "ATTACHMENT_INFO": "The document will be added to the file attachments.\nThe different offers included in the estimate must then be created one by one in BOOMERANG.",
    "GUARANTEE_WARNING": "Warning – Product under warranty\n\nThis product is currently identified as being under warranty.\nIf the manufacturer sends you a paid estimate, check that it is indeed a warranty exclusion before proceeding.",
    "ATTACHMENT_UPDATE": "Replace estimate",
    "ATTACHMENT_UPLOADED": "Document already added",
    "ATTACHMENT_MODAL_TITLE": "Add the repairer estimate",
    "REPAIRER_NUMBER": "Estimate number supplied by your repairer",
    "PLACEHOLDER": {
      "REPAIRER_NUMBER": "No. 1234"
    },
    "HINT": {
      "REPAIRER_NUMBER": "Enter only the estimate number supplied by the repairer. For Bosch, enter the order number."
    }
  },
  "ESTIMATE_REPAIRER_OFFER": {
    "SUB_TITLE": "Repairer offer",
    "TITLE_FORM": "Enter the repairer costs",
    "TRANSPORT_COST": "Repairer cost including transport",
    "LABOR_COST": "Repairer cost including transport and labor",
    "MARGIN": "Margin",
    "MODIFICATION_MARGIN": "Edit margin",
    "MODIFICATION_PRICE": "Edit price",
    "SAVE_MARGIN": "Save margin",
    "SAVE_PRICE": "Save price",
    "DETAIL_CLIENT": "Customer details",
    "CLIENT_PRICE": "Customer price",
    "CLIENT_PRICE_HT": "Customer price (excl. tax)",
    "REPAIRER_COST_SHORT": "Repairer cost",
    "NEW_OFFER": "New offer",
    "OFFER_TYPE": "Offer type",
    "REPAIR_COST_HT": "Repair cost (excl. tax)",
    "TRANSPORT_HT": "Transport (excl. tax)",
    "LABOR_HT": "Labor (excl. tax)",
    "INFO_CLIENT": "Remember to include a non-repair option for the customer",
    "PLACEHOLDER": {
      "OFFER_TYPE": "Select an offer type",
      "COMMENT": "Customer details",
      "ESTIMATE_COST": "E.g. 49.90",
      "LABOR_COST": "E.g. 49.90",
      "TRANSPORT_COST": "E.g. 49.90",
      "END_STATUS": "No. 1234"
    },
    "BUTTON": {
      "ADD_FORM": "Add a repairer offer",
      "SAVE": "Save",
      "VALIDATE_OFFER": "Validate offer"
    }
  },
  "ESTIMATE_REPAIRER_DETAIL": {
    "SUB_TITLE": {
      "SUMMARY": "Amount to offer customer (excl. tax)",
      "INFORM_CLIENT": "Inform customer"
    },
    "CUSTOMER_EMAIL_SAVE": "Customer email saved",
    "CALL_CLIENT": "I will call the customer and explain the prices",
    "SEND_ESTIMATE": "Send an estimate with these options",
    "BUTTON": {
      "SEND_EMAIL": "Email the options",
      "RESPONSE_CLIENT": "The customer is responding now",
      "CANCEL": "Resume the estimate later"
    },
    "PLACEHOLDER": {
      "COMMENT": "Comment"
    },
    "MODAL": {
      "SEND_CLIENT_EMAIL": "The options were emailed to the customer"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE": {
    "SUB_TITLE": "Repairer offer",
    "SAVE_MARGIN": "Save margin",
    "SAVE_PRICE": "Save price",
    "MODIFICATION_MARGIN": "Edit margin",
    "MODIFICATION_PRICE": "Edit price",
    "MARGIN": "Margin",
    "TRANSPORT_COST": "Repairer cost including transport",
    "LABOR_COST": "Repairer cost including transport and labor",
    "SEND_ESTIMATE_AGAIN": "Email the estimate again",
    "BUTTON": {
      "SEND_EMAIL": "Email the estimate options again"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION": {
    "TITLE": "Inform repairer and customer",
    "SUB_TITLE": {
      "CONTACT_REPAIRER": "1. Confirm the repair cost with the repairer",
      "CONTACT_CLIENT": "2. Confirm approval with the customer"
    },
    "LABEL": {
      "REPAIRER_PRICE": "Repair cost",
      "REPAIRER_PHONE": "Repairer phone",
      "REPAIRER_EMAIL": "Repairer email",
      "CUSTOMER_PHONE": "Customer phone",
      "CUSTOMER_EMAIL": "Customer email"
    },
    "BUTTON": {
      "SAVE": "Confirm automatically by email",
      "CANCEL": "Resume the estimate later"
    },
    "VALIDATION": "The options were emailed to the customer and repairer"
  },
  "FILE_STEP_GUARANTEE": {
    "TITLE": "Guarantee evaluation",
    "SUB_TITLE": "Search serial number",
    "SERIAL_PREREQUISITE": "Enter a valid serial number to continue guarantee evaluation.",
    "PURCHASE_EMPTY": "Enter a purchase date to calculate coverage.",
    "EXTENSION_EMPTY": "Enter an extension date to calculate coverage.",
    "DISTRIBUTOR_REF": "Distributor product references",
    "WARNING_TITLE": "Out of guarantee",
    "SUCCESS_TITLE": "Under guarantee",
    "GUARANTEE_TIME": "Guarantee duration",
    "PROOF_EXTENSION_GUARANTEE": "Guarantee-extension proof",
    "PROOF_PURCHASE_DATE": "Purchase-date proof",
    "GUARANTEE_TIME_REMAINING": "Remaining time",
    "DATE": "Purchase date",
    "DAYS": "days",
    "DAY": "day",
    "NO_DAY": "0 days",
    "TODAY": "Today",
    "END_DATE_EXTENSION_GUARANTEE": "Guarantee extension end date",
    "LOAD_ERROR": "Guarantee information could not be loaded.",
    "SERIAL_LOOKUP_ERROR": "Guarantee coverage could not be checked.",
    "RETRY": "Retry",
    "INVALID_DURATION": "The configured guarantee duration is invalid.",
    "NAMEPLATE_ALT": "Product nameplate",
    "PROOF_UPLOADED": "Document added",
    "REMOVE_PROOF": "Remove document",
    "UPLOAD_DESKTOP": "From computer",
    "UPLOAD_MOBILE": "Via mobile",
    "QR_TITLE": "Add document via mobile",
    "QR_HELP": "Scan this QR code with a mobile device, upload the document, then confirm here once it is sent.",
    "QR_CONFIRM": "Confirm upload",
    "QR_TOKEN_ERROR": "The mobile upload link could not be generated.",
    "QR_MISSING_UPLOAD": "No document received yet. Upload it from the mobile device, then try again.",
    "PLACEHOLDER": {
      "SEARCH": "Serial number"
    },
    "BUTTON": {
      "ENFORCE_SUPPORT": "Force support",
      "UNKNOWN_DATE": "I cannot find the purchase date",
      "CONTINUE": "Continue",
      "WITHOUT_EXTENSION": "Without extension"
    },
    "TEXT": {
      "SERIAL_NUMBER_EXAMPLE_ONE": "The serial number is usually located on the product nameplate.",
      "SERIAL_NUMBER_EXAMPLE_TWO": "Enter the full serial number to continue guarantee evaluation."
    },
    "FORCE_GUARANTEE_MODAL": {
      "TITLE": "Force support under guarantee",
      "MESSAGE": "The system indicates theoretical support, but the distributor can still force support under guarantee. Clearly explain the reason to the manufacturer / repairer so they can decide whether the support is relevant.",
      "SUB_TITLE_ONE": "Why should this repair be covered?",
      "SUB_TITLE_TWO": "Add supporting proof",
      "PLACEHOLDER": {
        "SUB_GUARANTEE": "Example: this machine was repaired by the manufacturer 3 months ago and is therefore under guarantee.",
        "FILE": "Guarantee or repair invoice"
      },
      "BUTTON": "Confirm reason"
    },
    "EXCLUSION_GUARANTEE_MODAL": {
      "TITLE": "Support exclusions for this product",
      "BUTTON": {
        "VALID": "Confirm evaluation"
      }
    },
    "ERROR": {
      "SERIAL_NUMBER_NOT_FOUND_FOR_EXTENSION": "The serial number was not found for a guarantee extension",
      "SERIAL_NUMBER_NOT_FOUND_FOR_PROLONGATION": "Unknown serial number for guarantee prolongation",
      "SERIAL_NUMBER_NOT_GOOD_FORMAT": "Serial number must contain {value} character(s).",
      "SERIAL_NUMBER_NOT_UNKNOWN": "No serial-number format is configured for this product"
    }
  },
  "FILE_STEP_PRICING": {
    "FORCE_ESTIMATE": {
      "TITLE": "Estimate",
      "DESCRIPTION": "Only for repairs performed in-store or by an independent repairer",
      "VALIDATE": "Request an estimate outside the manufacturer network"
    },
    "TITLE": "Pricing",
    "LOAD_ERROR": "Pricing information could not be loaded.",
    "FREE_SUPPORT": "Free",
    "GUARANTEE_COVERAGE": "Warranty coverage",
    "CUSTOMER_CODE": "Review the codes and adjust the package below if needed",
    "RETURN_CLIENT_TRANSPORT_COST": "I would like to include the cost of CHRONOPOST RETURN transport after after-sales service, from my store to my customer's home. This transport option is available at the STORE RECEIPT step.",
    "PLACEHOLDER": {
      "CUSTOMER_CODE": "Code"
    },
    "TOOLTIP": {
      "S_1": "Increase the package:",
      "T_1": "add P8 through P50; the number is the increase amount (P50 = +€50)",
      "S_2": "Decrease the package:",
      "T_2": "add M8 through M50; the number is the discount amount (M8 = -€8)",
      "S_3": "Recycling:",
      "T_3": "enter the take-back code shown on your transfer certificate"
    },
    "PACKAGE_INFO": {
      "PACKAGE": "Package",
      "ESTIMATE": "Request a repair estimate",
      "REPAIR_TIME": "Observed average repair time",
      "REPAIR_COST": "Repair package",
      "TRANSPORT_COST": "Transport cost",
      "ESTIMATE_TRANSPORT_COST": "Estimated outbound transport cost",
      "ADDITIONAL_COST": "Management cost",
      "REPAIR_FUND": "Repair fund",
      "REPAIR_AMOUNT": "Repair amount",
      "WITH_DIAGNOSTIC": "according to diagnosis",
      "DIAGNOSTIC_COST": "Repairer diagnostic fee (if refused)",
      "CLIENT_PRICE_TOOLTIP": {
        "PACKAGE": "Package: {networkCode}\n+ amount invoiced by the manufacturer to the store\n= {amount} {euro}",
        "ESTIMATE": "Estimated repair cost payable by the store = {amount} {euro}. (Pending the manufacturer's actual estimate).\n*The customer agrees to pay the displayed total regardless of the estimate amount."
      },
      "DAYS": "days",
      "NOT_PROVIDED": "Not provided",
      "ESTIMATE_PACKAGE": "Send package estimate",
      "PRODUCT_NEW_PRICE": "Indicative/retail price"
    },
    "MODAL": {
      "PACKAGE_ESTIMATE": {
        "TITLE": "Package estimate",
        "SUB_TITLE": "Send the package estimate request to:",
        "FILE_INPUT": {
          "PACKAGE": "Customer after-sales form"
        },
        "LABEL": {
          "COMMENT": "Additional information",
          "COMPANY_NAME": "Company name",
          "CUSTOMER_NAME": "Customer name",
          "EMAIL_CONTACT": "Contact email address",
          "PHONE_NUMBER": "Phone number"
        },
        "MOBILE_NUMBER_HINT": "This number cannot be used to send an SMS notifying the customer that the product is available. Enter a mobile number.",
        "PLACEHOLDER": {
          "COMMENT": "Example: Offer a new product for €245"
        },
        "VALIDATION_BUTTON": "Send",
        "BOTTOM_TEXT": "Once the package estimate is sent to the customer, the file will be saved and remain editable",
        "MESSAGE": {
          "VALIDATION": "The package estimate was emailed successfully to your customer"
        }
      }
    }
  },
  "FILE_STEP_CREATE_FOLDER": {
    "TITLE": "Client information",
    "SUBTITLE": "Check the contact details used to create the repair file.",
    "SUB_TITLE": {
      "GENERAL_INFORMATION": "Company contact information for after-sales service management",
      "ATTACHMENT": "Document to attach to the repair file"
    },
    "FORM": {
      "ERP_MODE": "Automatic creation in ITECH",
      "NAME": "Contact name",
      "COMPANY": "Company",
      "MAIL": "Email address",
      "PHONE": "Phone",
      "WORKSITE_CODE": "Worksite / allocation / internal code",
      "COMPANY_SELECTOR": "Select the company from the list",
      "KEY_ACCOUNT_CLIENT": "This client is a Key Account",
      "OPERATING_CENTER": "Operating center"
    },
    "PLACEHOLDER": {
      "NAME": "Contact name",
      "COMPANY": "Company name",
      "MAIL": "Email address",
      "PHONE": "Phone number",
      "WORKSITE_CODE": "Worksite / allocation / internal code",
      "COMPANY_SELECTOR": "Select a company",
      "OPERATING_CENTER": "Select an operating center"
    },
    "HELP_TEXT": {
      "DISABLE_ERP": "If your client does not have an ITECH account, turn off the Automatic creation in ITECH switch",
      "RGPD_RULES": "GDPR: Once the repair file is closed, the personal data entered above will be deleted automatically"
    },
    "FILE_INPUT": {
      "BILLING": "Customer invoice",
      "EXTENSION_GUARANTEE": "Guarantee extension",
      "ASBESTOS_SHEET": "Asbestos declaration",
      "FORCE_GUARANTEE": "Supporting document to force coverage",
      "DEFAULT": "Supported files: pdf, jpg, png",
      "DEFAULT_WARNING": "Missing required document",
      "DEFAULT_WARNING_ASBESTOS": "Missing optional document"
    },
    "MODAL": {
      "TITLE": {
        "BILLING": "Proof of purchase date",
        "EXTENSION_GUARANTEE": "Proof of guarantee extension date",
        "ASBESTOS_SHEET": "Asbestos certificate",
        "FORCE_GUARANTEE": "Proof to force coverage"
      },
      "BUTTON": {
        "VALIDATE": "Send"
      }
    },
    "SUBMIT": "OPTION 1: All brands, I do not know the process; I request coverage from the manufacturer",
    "EXPERT_MODE": "OPTION 2: PRAMAC, RUBI, ABAC and LECIA only; EXPERT process, I select the repairer directly"
  },
  "FILE_STEP_STORE_INTERNAL": {
    "TITLE": "Store internal information",
    "FORM": {
      "INTERNAL_COMMAND_NUMBER": "Supplier order number",
      "INTERNAL_COMMAND_NUMBER_HINT": "To change the supplier order number, use a MAXIMUM of 10 characters, UPPERCASE ONLY and NO SPACES. Proper coordination with repairers is essential: any discrepancy will make tracking more difficult"
    },
    "PLACEHOLDER": {
      "INTERNAL_COMMAND_NUMBER": "Enter the supplier order number"
    }
  },
  "REPAIR_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "IN_CREATION": "1. In creation",
      "TRANSPORT_GO": "2. Outbound collection",
      "RECEPTION_AT_REPAIRER": "3. Received by repairer",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "4. Estimate sent by manufacturer",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "5. Manufacturer estimate added",
      "ESTIMATE_SENT_TO_CUSTOMER": "6. Estimate sent to customer",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "7. Customer decision sent to repairer",
      "IN_REPARATION": "8. In repair",
      "SENT_BACK_BY_REPAIRER": "9. Shipped by repairer",
      "RECEIPT_AT_STORE": "10. Received at store",
      "SENT_AVAILABLE_TO_CUSTOMER": "11. Customer notified",
      "TAKEOVER_BY_CUSTOMER": "12. Handed to customer - closed",
      "NETWORK_BILLING": "13. Billing",
      "FINISHED": "14. File completed"
    },
    "STATUS_ACTION": {
      "VALIDATE_RECEIPT": "Validate receipt"
    },
    "REPAIR_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Product",
        "SUMMARY": "Summary",
        "SUPPORT": "Support",
        "CONTACT": "Contact",
        "PRICING": "Detailed pricing",
        "PROSPECT_FLOW": "Pre-approval request",
        "PROGRESSION": "Progress"
      },
      "CLIENT_NUMBER": "Customer account no.",
      "PRODUCT_IMAGE": "Product image",
      "SERIAL_NUMBER": "Series",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "CLIENT_CODE": "Client code",
      "LASTNAME": "Contact name",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone",
      "WORKSITE_CODE": "Worksite code",
      "MODE": "Mode",
      "PRICING": "Customer pricing (excl. tax)",
      "SUPPORT": "Support initially requested",
      "GESTION": "Management",
      "ELEMENT": "Items concerned",
      "GUARANTEE": "Initial warranty",
      "UNDER_GUARANTEE": "Under warranty",
      "OUT_GUARANTEE": "Out of warranty",
      "TRANSPORT_COST": "Transport cost",
      "TRANSPORT_PRICE": "Transport price",
      "MANAGEMENT_COST": "Management cost",
      "MANAGEMENT_PRICE": "Management price",
      "REPAIR_COST": "Estimated repair price (excl. tax)",
      "REPAIR_FUND": "Repair fund",
      "PACKAGE_CODE": "Manufacturer package code",
      "PACKAGE_TOTAL_COST": "Total cost (excl. tax)",
      "PACKAGE_SUPPORT_COST": "Support price (excl. tax)",
      "NETWORK_PACKAGE_CODE": "Distributor package code",
      "ESTIMATE": "Repair estimate cost",
      "ESTIMATE_VALIDATE_BY_CUSTOMER": "Offer approved by customer",
      "ESTIMATE_VALIDATE_TAKEOVER_BY_CUSTOMER": "Final customer offer",
      "ESTIMATE_VALIDATE_COST": "Cost invoiced by repairer (excl. tax)",
      "ESTIMATE_VALIDATE_DETAIL_ESTIMATE_COST": "Repair cost (excl. tax)",
      "ESTIMATE_VALIDATE_DETAIL_TRANSPORT_COST": "Transport cost (excl. tax)",
      "ESTIMATE_VALIDATE_DETAIL_LABOR_COST": "Labor cost (excl. tax)",
      "ESTIMATE_VALIDATE_DETAIL_REPAIR_COST": "Total repair cost (excl. tax)",
      "ESTIMATE_VALIDATE_TRANSPORT_COST": "Transport price included in support (excl. tax)",
      "ADDITIONAL_REPAIR_COST": "Management price",
      "CUSTOMER_END_COST": "Total customer price (excl. tax)",
      "REPAIR_FILE_IN_PROGRESS": "Repair file in progress",
      "TAKEOVER_BY_CUSTOMER": "Handed over to customer",
      "NO_PRICE": "- €",
      "CLIENT_LABEL": "Customer",
      "REPAIRER_LABEL": "Repairer",
      "REPAIRER_COST_MAX": "Maximum repair cost (excl. tax)",
      "COMMENT": "Comments:",
      "PRICING_STATUS": {
        "ESTIMATE_VALIDATED": "Estimate approved",
        "WAITING_CUSTOMER_DECISION": "Awaiting customer decision",
        "ESTIMATE_TO_INTEGRATE": "Estimate to be added",
        "BOSCH_PACKAGE_VALIDATED": "Bosch package approved",
        "PACKAGE_VALIDATED": "Package approved"
      }
    },
    "ESTIMATE_OPTION_STATUS": {
      "PRODUCT_REPAIRED": "Product repaired",
      "PRODUCT_REPLACED_STANDARD": "Standard product replacement",
      "PRODUCT_REPLACED_SUPERIOR": "Upgrade product replacement",
      "PRODUCT_CREDIT": "Credit note",
      "PRODUCT_RECYCLED": "Not repaired: recycling",
      "PRODUCT_RETURN_DISASSEMBLED": "Not repaired: returned disassembled",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Pre-approval: repair under warranty",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Pre-approval: repair outside warranty",
      "PROSPECT_CREDIT_OR_REFUND": "Pre-approval: credit note",
      "PROSPECT_REPLACEMENT": "Pre-approval: replacement",
      "PROSPECT_REJECT": "Pre-approval: support declined",
      "PROSPECT_OTHER": "Pre-approval: other"
    },
    "HEADER": {
      "TITLE": "Repair request summary",
      "DAYS": " days",
      "DAY": " day"
    },
    "BUTTON": {
      "NEW_ACTION": "New action"
    }
  },
  "REPAIR_FILE_ATTACHMENT": {
    "TITLE": "Attachments",
    "BUTTON": {
      "ADD": "Add"
    },
    "CARD": {
      "CUSTOMER_SATISFACTION": "Customer satisfaction",
      "TRANSPORTER_ORDER": "Shipping label",
      "REPAIR_ORDER": "Repair order",
      "BILLING": "Customer invoice",
      "GUARANTEE": "Warranty extension",
      "FORCE_GUARANTEE": "Forced warranty",
      "REPAIRER_ESTIMATE": "Repairer estimate",
      "ASBESTOS": "Asbestos declaration",
      "AFTER_SALE_SERVICE": "Customer after-sales form",
      "DANGER_LABEL": "Dangerous goods label",
      "ESTIMATE_PACKAGE": "Package estimate",
      "GUARANTEE_EXTENSION_BOOMERANG": "Delivery note and Boomerang warranty certificate",
      "REPAIR_FILE_PROSPECT_ORDER_WAITING": "Pre-approval request",
      "DELIVERY_NOTE": "Delivery note to sign",
      "TRANSPORTER_DOCUMENT_FOR_REPAIRER": "Repairer-specific transport document"
    },
    "MODAL": {
      "ACCEPTED_FORMATS": "Accepted formats: PDF, JPG, PNG, JPEG",
      "FILE": "Add your attachment",
      "FILE_NAME": "File name",
      "GENERIC_TITLE": "Add an attachment",
      "QR_CODE_SUBTITLE": "Scan this QR code with a mobile device to add the attachment.",
      "QR_CODE_TITLE": "Add an attachment with a QR code",
      "QR_CONFIRM": "I added the document",
      "QR_UPLOAD_MISSING": "No document has been added with the QR code yet.",
      "SUBTITLE": "Add a file from this computer or generate a QR code to add it from a mobile device.",
      "UPLOAD_VIA_MOBILE": "Add with QR code",
      "VISIBLE_TO_KEY_ACCOUNT": "Document visible to the customer"
    },
    "PLACEHOLDER": {
      "FILE_NAME": "File name"
    },
    "PROSPECT_PICTURE_NAME_LABEL": "Photo-",
    "PROSPECT_DOCUMENT_NAME_LABEL": "Document-",
    "PERMISSION": {
      "VIEW_ATTACHMENT_REPAIR_FILE_DENIED": "You do not have permission to view repair file attachments.",
      "PRINT_ATTACHMENT_REPAIR_FILE_DENIED": "You do not have permission to download repair file attachments."
    }
  },
  "INFORMATION_REPAIR_FILE": {
    "CLIPBOARD_COPY": "Store contact address copied to clipboard",
    "CLIPBOARD_COPY_ERROR": "Could not copy the address to the clipboard",
    "CONTENT": "Support",
    "REPAIR_CENTER": {
      "ADDRESS": "Address",
      "EMAIL": "Contact address",
      "ERP_REPAIRER_NUMBER": "Repairer account number",
      "NAME": "Name",
      "PHONE": "Phone number",
      "REPAIRER_NUMBER": "Repairer file number",
      "TITLE": "Repairer"
    },
    "STORE": {
      "ADDRESS": "Address",
      "EMAIL": "Contact address",
      "NAME": "Name",
      "PHONE": "Phone number",
      "TITLE": "Store"
    },
    "TRANSPORTER_MODALITY": {
      "TRANSPORTER": "Transporter",
      "WORKSHOP": "Workshop",
      "STORE": "Store",
      "EXCLUDING_SUPPORT": "Out of process"
    },
    "REPAIR_LOCATION": {
      "EXTERNAL_REPAIRER": "External repairer",
      "STORE_WORKSHOP": "Store workshop",
      "CUSTOMER_WORKSHOP": "Customer workshop"
    }
  },
  "COMMENTARY_REPAIR_FILE": {
    "INFO_ALERT": "The Boomerang team is not alerted about your comments. To contact us, press Chat (green bubble at the bottom right).",
    "BUTTON": {
      "SEND": "Send"
    },
    "PLACEHOLDER": {
      "COMMENTARY": "Add a comment"
    },
    "VISIBILITY": {
      "KEY_ACCOUNT": "Share with customer user"
    },
    "INVISIBLE_TO": "Hidden from {targets}",
    "VISIBILITY_TARGET": {
      "KEY_ACCOUNT": "Customer user"
    },
    "TYPE": {
      "STORE": "Store team",
      "KEY_ACCOUNT": "Customer user",
      "ADMIN": "BOOMERANG team",
      "EXTERNAL": "External",
      "REPAIRER": "Repairer"
    },
    "TITLE": "Comments"
  },
  "TRANSPORTER_REPAIR_FILE": {
    "TITLE": "Outbound/Return addresses",
    "GO_DEPARTURE_ADDRESS": "OUTBOUND - DEPARTURE ADDRESS",
    "GO_DESTINATION_ADDRESS": "OUTBOUND - DESTINATION ADDRESS",
    "RETURN_REPAIRER_ADDRESS": "RETURN - RETURN ADDRESS",
    "TRANSPORTER_GO": "Outbound transport",
    "ADDRESS_NAME": "Address name",
    "ADDRESS": "Address",
    "CITY": "City",
    "TRANSPORT_TYPE": "Transport type",
    "TRANSPORTER": "Transporter",
    "FINALIZATION_DATE": "File finalization date",
    "COLLECT_STATUS": "Collection request",
    "EXPEDITION_DATE": "Shipping date",
    "TRACKING_NUMBER": "Tracking number",
    "PACKAGE_WEIGHT": "Package weight",
    "PALLET": "Transport with pallet",
    "TRANSPORTER_LOGIN": "Transport contract login",
    "TYPE": {
      "IMMEDIATE_TRANSPORTER": "Immediate transporter",
      "CUSTOMER_SERVICE_TRANSPORTER": "Customer service transporter",
      "WITHOUT_TRANSPORTER": "Without transporter"
    }
  },
  "TRANSPORTER_RENTAL_FILE": {
    "TITLE": "Transport",
    "TRANSPORTER_GO": "Outbound transport",
    "ADDRESS_NAME": "Address name",
    "ADDRESS": "Address",
    "ADDRESS_COMPLEMENT_1": "Address line 2",
    "ADDRESS_COMPLEMENT_2": "Address line 3",
    "CITY": "City",
    "COUNTRY": "Country",
    "DESIRED_RECEPTION_DATE": "Desired delivery date",
    "TRACKING_NUMBER": "Tracking number",
    "TRANSPORTER_TYPE": "Transporter",
    "TRANSPORT_SEND_DATE": "Shipping date"
  },
  "RENTAL_FILE_DETAIL": {
    "BOOMERANG_ID": "No. ",
    "NOT_FOUND": "The rental file could not be found"
  },
  "COMMENTARY_RENTAL_FILE": {
    "TITLE": "Comments",
    "INFO_ALERT": "The Boomerang team is not alerted about your comments. To contact us, press Chat (green bubble at the bottom right).",
    "BUTTON": {
      "SEND": "Send"
    },
    "PLACEHOLDER": {
      "COMMENTARY": "Add a comment"
    }
  },
  "DAY_SUPP_COUNT_DATE_RENTAL_FILE": {
    "TITLE_1": "Number of additional days",
    "TITLE_2": "(From two days after the after-sales return)",
    "DAYS": "Days"
  },
  "RENTAL_FILE_ATTACHMENT": {
    "TITLE": "Attachments",
    "CARD": {
      "CGV": "Terms and conditions",
      "ADD_ATTACHMENT": "Add an attachment"
    },
    "BUTTON": {
      "ADD": "Add"
    },
    "MODAL": {
      "FILE_NAME": "File name",
      "FILE": "Add your attachment"
    },
    "PERMISSION": {
      "VIEW_ATTACHMENT_DENIED": "You are not authorized to view attachments",
      "PRINT_ATTACHMENT_DENIED": "You are not authorized to download this attachment"
    }
  },
  "RENTAL_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "CREATED": "1. File created",
      "CONTRACT_SENT": "2. Contract sent",
      "PACKET_PREPARATION": "3. Parcel preparation",
      "TRANSPORT_GO": "4. Outbound transport",
      "CLIENT_RECEIPT": "5. Received by customer",
      "CLIENT_INFORMED": "6. Customer notified",
      "STORE_RECEIPT": "7. Rental received at store",
      "TRANSPORT_BACK": "8. Return transport",
      "BOOMERANG_RECEIPT": "9. Received by Boomerang",
      "BILLING": "10. Out-of-contract billing",
      "CLOSED": "11. Closed"
    },
    "HEADER": {
      "TITLE": "Rental request summary",
      "DAYS": " days",
      "DAY": " day"
    },
    "RENTAL_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Product",
        "SUMMARY": "Summary",
        "PRICING": "Detailed pricing"
      },
      "PRODUCT_IMAGE": "Product image",
      "SERIAL_NUMBER": "Series",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "LASTNAME": "Signatory name",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone",
      "CLIENT_RENTAL_COST": "Customer rental price:",
      "CLIENT_RENTAL_COST_PACKAGE_NAME": "Customer rental package:",
      "CLIENT_ADDITIONAL_DAY_COST": "Customer price per additional day:",
      "CLIENT_ADDITIONAL_DAY_PACKAGE_NAME": "Customer additional-day package:",
      "DEPOSIT": "Deposit:",
      "DEPOSIT_TYPE": "Deposit method:"
    },
    "DEPOSIT_TYPE": {
      "STORE": "Store",
      "SWIKLY": "Swikly"
    }
  },
  "FILE_STEP_BREAKDOWN": {
    "TITLE": "Describe the breakdown",
    "DESCRIPTION": "What problem do you see?",
    "PRODUCT_BREAKDOWN": "Breakdown type",
    "LOAD_ERROR": "Breakdown information could not be loaded.",
    "PLACEHOLDER": {
      "DESCRIPTION": "Briefly describe the observed issue",
      "PRODUCT_BREAKDOWN": "Select breakdown type"
    },
    "PRODUCT_QUESTION_MODAL": {
      "TITLE": "Questions - {breakdown}",
      "MESSAGE": "Answer the questions linked to the selected breakdown type."
    },
    "DIALOG": {
      "TITLE": "Problem with",
      "CONTENT": "Before requesting a repair, make sure this accessory is not causing the breakdown. If the accessory is responsible, the manufacturer may charge transport costs and will not repair the product."
    },
    "BUTTON": {
      "NOT_FOUND_BREAKDOWN": "I cannot find the breakdown type"
    }
  },
  "FILE_STEP_PRODUCT": {
    "TITLE": "Select the product",
    "LOAD_ERROR": "Unable to load products.",
    "STORE_UNAVAILABLE": "You no longer have access to the store associated with this file.",
    "PLACEHOLDER": {
      "MANUFACTURER": "Select brand",
      "CATEGORY": "Select range",
      "SUB_CATEGORY": "Select sub-range",
      "NO_PRODUCT": "No product"
    },
    "SELECT": {
      "MANUFACTURER": "What is the product brand?",
      "CATEGORY": "What is the product range?",
      "SUB_CATEGORY": "What is the product sub-range?"
    },
    "LABEL": {
      "PRODUCT": "Select the product",
      "PRODUCT_POPULAR": "Most popular products",
      "NO_REPARABLE": "Not repairable"
    },
    "BUTTON": {
      "ADD_PRODUCT": "Request addition",
      "ADD_PRODUCT_QUESTION": "Can't find your product?"
    },
    "CLIENT_NUMBER_MODAL": {
      "TITLE": "Enter a customer account number"
    },
    "STORE_MODAL": {
      "TITLE": "Store selection",
      "MESSAGE": "Select the store concerned to start a file",
      "PLACEHOLDER": "Store"
    },
    "ASBESTOS_MODAL": {
      "TITLE": "Has the product been exposed to asbestos?"
    }
  },
  "ASK_PRODUCT_CREATION": {
    "TITLE": "Request product creation",
    "MESSAGE": "Add the details visible on the nameplate. Response within 8 to 24h.",
    "DROPZONE_TITLE": "Drop the nameplate photo",
    "ACCEPTED_FORMATS": "Accepted formats: JPG, JPEG, PNG",
    "NAMEPLATE_HINT": "Nameplate photo. If there is no nameplate, add a photo of the full product.",
    "TAKE_PHOTO": "Take a photo",
    "QR_UPLOADED": "Photo added with QR code.",
    "QR_VALIDATION_ERROR": "No photo has been added with QR code yet.",
    "LABEL": {
      "EMAIL": "Contact email",
      "MANUFACTURER": "Brand",
      "PRODUCT_NAME": "Product name",
      "PRODUCT_CODE": "Product code / reference",
      "SENDER_NAME": "Your client's company name (to resume the file later)",
      "NAMEPLATE": "Nameplate",
      "NAMEPLATE_VALIDATION_CHECKBOX": "I confirm I added the photo with QR code",
      "UNDER_GUARANTEE": "Under warranty"
    },
    "BUTTON": {
      "UPLOAD_WITH_QR_CODE": "Add with QR code"
    },
    "SUBMIT": "Send request (response within 8-24h)",
    "SUCCESS": "Your product creation request has been sent.",
    "QR_MODAL": {
      "MESSAGE": "Scan this QR code to take a photo of the nameplate. Tick the checkbox once this step is complete."
    },
    "QR_PAGE": {
      "TITLE": "Add a photo",
      "SUBTITLE": "Add the nameplate photo from your phone.",
      "DROPZONE_TITLE": "Drop the photo",
      "ACCEPTED_FORMATS": "JPG, JPEG, PNG",
      "HINT": "Nameplate photo. If there is no nameplate, add a photo of the full product.",
      "TAKE_PHOTO": "Take a photo",
      "REMOVE_FILE": "Remove photo",
      "SUBMIT": "Send photo",
      "TITLE_SENT": "Photo sent",
      "MESSAGE_SENT": "You can return to your computer to complete the request.",
      "TITLE_ERROR_TOKEN_VALIDITY": "Expired or invalid link",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Generate a new QR code from the request."
    }
  },
  "REPAIR_FILE_RECAP": {
    "STEP_ONE": {
      "TITLE": "Selected product",
      "MANUFACTURER": "Brand",
      "CATEGORY": "Range",
      "SUB_CATEGORY": "Sub-range",
      "PRODUCT": "Product",
      "SERIAL_NUMBER": "Serial no"
    },
    "STEP_TWO": {
      "TITLE": "Breakdown reason",
      "BREAKDOWN": "Breakdown description",
      "TYPE": "Broken elements"
    },
    "STEP_THREE": {
      "TITLE": "Coverage",
      "GUARANTEE": {
        "TITLE": "Coverage",
        "UNDER_GUARANTEE": "Under guarantee",
        "OUT_GUARANTEE": "Out of guarantee"
      }
    },
    "STEP_FOUR": {
      "TITLE": "Pricing",
      "PACKAGE": "Package",
      "ESTIMATE": "Estimate",
      "CUSTOMER_CODE": "Customer / Prospect",
      "AMOUNT": "Amount",
      "DELAY": "Average delay",
      "DAYS": "{count} days",
      "ASK_ESTIMATE": "Request a repair estimate",
      "TOOLTIP": {
        "HEADER": "Unable to repair?\nRecycle it!",
        "CONTENT": "Use our recycling support to dispose of your equipment."
      }
    },
    "STEP_FIVE": {
      "TITLE": "Customer information",
      "COMPANY": "Company",
      "NAME": "Last name / first name",
      "CONTACT": "Contact"
    },
    "STEP_SIX": {
      "TITLE": "Store internal information",
      "INTERNAL_COMMAND_NUMBER": "Supplier order number"
    }
  },
  "ATTACHMENT_MODAL": {
    "QR_CODE_PAGE": {
      "TITLE": "Add supporting proof",
      "MESSAGE": "Select a file or take a photo, then send it to the repair file.",
      "SELECT_TITLE": "Drop or select your proof",
      "TITLE_SENT": "Your proof was added",
      "MESSAGE_SENT": "Return to the computer to continue creating the repair file.",
      "TITLE_ERROR_TOKEN_VALIDITY": "This link has expired or is invalid",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Request a new mobile upload link from Boomerang.",
      "LOADING": "Checking the link...",
      "ACCEPTED_FORMATS": "Accepted formats: PDF, JPG, JPEG, PNG",
      "TAKE_PHOTO": "Take a photo",
      "REMOVE_FILE": "Remove file",
      "TITLE_FAILED": "Unable to check this link",
      "MESSAGE_FAILED": "An error occurred. You can retry."
    }
  },
  "STEPPER": {
    "TITLE": "Repair file in creation",
    "ARIA_LABEL": "Repair file creation steps",
    "LOAD_ERROR": "Unable to load this repair file.",
    "RETRY": "Retry",
    "SUMMARY": {
      "NO_FOLDER": "No folder created",
      "NO_PRODUCT": "Select a product to create the draft repair file."
    },
    "SUBTITLE": {
      "PRODUCT": "Select the affected product",
      "BREAKDOWN": "Describe the breakdown reason",
      "GUARANTEE": "Evaluate guarantee coverage",
      "PRICING": "Select matching pricing",
      "CLIENT_INFORMATION": "Fill customer information",
      "STORE_INFORMATION": "Fill store internal information",
      "FILE_INFORMATION": "Fill repair file information",
      "TRANSPORT": "Configure transport"
    },
    "STEP": {
      "ONE": "Product",
      "TWO": "Breakdown reason",
      "THREE": "Guarantee evaluation",
      "FOUR": "Pricing",
      "FIVE": "Customer information",
      "FIVE_PROSPECT": "Store internal information",
      "SIX": "Store internal information",
      "SIX_PROSPECT": "File information",
      "SEVEN": "Transport"
    }
  },
  "SHIPPING_PAGE": {
    "TITLE": { "SHIPPING": "Shipping" },
    "PAGE_SUBTITLE": "Prepare and generate the repair-file shipment",
    "BACK_TO_TRANSPORT": "Back to transport options",
    "SUMMARY_IN_PROGRESS": "Repair file shipment in progress",
    "ADDRESS": "Address",
    "CITY": "City",
    "WEIGHT": "Weight",
    "WIDTH": "Width",
    "LENGTH": "Length",
    "LOAD_ERROR": "Unable to load shipping information.",
    "UNSUPPORTED_CARRIER": "This carrier does not support shipment generation from this page.",
    "ORDER_TAG": "No. {number}",
    "TRANSPORTER_SUBTITLE": "Express pickup with automatic label",
    "TRANSPORTER_NAME": { "CHRONOPOST": "Chronopost", "TNT": "TNT" },
    "DEPARTURE": "Departure",
    "UPDATE_DEPARTURE": "Edit departure address",
    "DELIVERY": "Delivery",
    "CHRONOPOST_CONSTRAINTS": "Chronopost constraints",
    "CHRONOPOST_PARCEL_CONFIRMATION": "By validating this step, you confirm that the prepared parcel meets the conditions below:",
    "CHRONOPOST_SURCHARGE_WARNING": "Otherwise, Chronopost will charge an additional fee of at least €70.",
    "COLLECT_TITLE": "Generate a label without pickup",
    "COLLECT_SUBTITLE": "Generate the shipping label without scheduling a pickup.",
    "EARLY_COLLECT": "Earliest pickup time",
    "LAST_COLLECT": "Latest pickup time",
    "MAX_CREATION": "Shipment creation deadline",
    "SHIPPING_DAY": "Pickup date",
    "WISHED_COLLECT_DATE": "Requested pickup date:",
    "WISHED_DELIVERY_DATE": "Requested delivery date:",
    "DETAIL_SHIPPING": "Shipment details",
    "MISSING_DATA": "Enter 0 if the dimensions are unknown",
    "HEIGHT": "Height (cm)",
    "PACKAGE": "Package",
    "SUBTITLE": {
      "CHRONOPOST_CONSTRAINTS": "Pickup date and time window",
      "DEPARTURE": "Pickup address",
      "DELIVERY": "Repairer address",
      "PACKAGE": "Package specifications"
    },
    "MESSAGE": {
      "SUCCESS": {
        "FEASIBILITY_MESSAGE": "Chronopost pickup is available.",
        "GENERATE_MESSAGE": "Chronopost shipment created.",
        "TNT_GENERATE_MESSAGE": "TNT shipment created.",
        "SWITCH_CHRONOPOST": "Carrier switched to Chronopost"
      },
      "ERROR": {
        "MISSING_SERVICE": "No Chronopost shipping service is available.",
        "INVALID_CONSTRAINTS": "Chronopost constraints do not allow this shipment to be scheduled.",
        "INVALID_COLLECTION": "The pickup date or time is no longer valid. Refresh the constraints and choose another pickup date.",
        "CHRONOPOST": "Chronopost could not process the request. Please try again.",
        "HANDLE_UNIT_SHIPPED": "The handling unit has been shipped."
      }
    },
    "BUTTON": {
      "FEASIBILITY": "Check pickup availability",
      "GENERATE_SEND": "Generate shipment"
    },
    "TNT_RECONCILIATION": {
      "TITLE": "TNT accepted the pickup — reconciliation required",
      "DO_NOT_RESUBMIT": "Do not book another pickup or switch carriers. TNT has already accepted this request.",
      "INSTRUCTIONS": "Recover the pickup confirmation and transport document from TNT before finalizing. Contact Boomerang support with the repair-file reference if reconciliation is needed. Reviewing the saved file does not create another pickup.",
      "RECEIPT_NOT_SAVED": "The booking receipt could not be saved in Boomerang. Do not resubmit, even after reloading. Contact Boomerang support to record the accepted pickup before continuing.",
      "REFERENCE": "TNT pickup reference: {reference}",
      "REVIEW": "Review the saved file",
      "NOT_READY": "The saved file is not ready for finalization. Contact Boomerang support to reconcile the accepted pickup. You can leave this page without changing transport or booking again."
    },
    "TNT_PREPARATION": {
      "TITLE": "Prepare TNT shipment",
      "SUBTITLE": "Pickup date and label generation",
      "LOAD_ERROR": "Unable to load TNT pickup options.",
      "AVAILABLE": "TNT pickup is available on the displayed date.",
      "CONFIRMATION": "TNT pickup is no longer available today. You can confirm pickup on the next business day or choose Chronopost if available.",
      "REFRESH_NOTICE": "Pickup availability will be checked again when generating the shipment."
    },
    "TNT_PROGRESS": {
      "TITLE": "TNT progress",
      "SUBTITLE": "Label generation progress",
      "WAITING": "Waiting for manual generation...",
      "PROCESSING": "Processing...",
      "LAST_EVENT_LABEL": "Latest event",
      "HISTORY_LABEL": "History"
    },
    "TNT_PICKUP_OPTIONS": {
      "TITLE": "TNT pickup unavailable today",
      "DESCRIPTION_PREFIX": "TNT pickup will be scheduled on the next business day:",
      "DESCRIPTION_SUFFIX": "Choose how to continue.",
      "POSTPONE_TNT": "Postpone TNT pickup until the next business day",
      "SWITCH_CHRONOPOST": "Switch to the earliest available Chronopost pickup"
    },
    "PLACEHOLDER": { "CHRONOPOST_SERVICE": "Select your Chronopost service" }
  },
  "RENTAL_UPDATE_STATUS_STORE_RECEIPT_MODAL": {
    "RETRY_QR_CODE": "Try again"
  }
}
